import {
  c as K,
  P as w,
  f,
  u as _,
  r as X,
  a as Z,
  b as B,
  d as b,
  N as F,
  e as v,
  A as k,
  T as V,
  E as ee,
  g as te,
  S as se,
  h as ie,
  i as ne,
  j as re,
  k as oe,
  l as ae,
  m as ce,
  n as R,
  o as le,
  s as de,
  p as D,
  q as ue,
} from "./vendor@theme.Cx8BRFo5.min.js";
const he = class extends HTMLElement {
    constructor() {
      (super(),
        (this.selector = { handle: ".u-accordion-handle" }),
        (this.$handles = Array.from(
          this.querySelectorAll(this.selector.handle),
        ).filter((e) => e.closest(this.localName) === this)),
        (this.$handle = this.$handles && this.$handles[0]),
        this.addEventListener("click", this.toggleHandler.bind(this)),
        window.Shopify.designMode &&
          (this.addEventListener(
            "shopify:block:select",
            () => (this.open = !0),
          ),
          this.addEventListener(
            "shopify:block:deselect",
            () => (this.open = !1),
          )));
    }
    static get observedAttributes() {
      return ["open"];
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(e) {
      e ? this.setAttribute("open", "") : this.removeAttribute("open");
    }
    get closeSiblings() {
      return this.dataset.closeSiblings || null;
    }
    get siblingsAccordions() {
      return (
        (this.closest(this.closeSiblings) &&
          this.closest(this.closeSiblings).querySelectorAll(this.localName)) ||
        null
      );
    }
    get followFocus() {
      return this.dataset.followFocus === "true";
    }
    get firstFocusableElement() {
      return (
        this.querySelectorAll(
          "button:not("
            .concat(this.selector.handle, "), a:not(")
            .concat(
              this.selector.handle,
              '), input:not([type="hidden"]), select, textarea, [tabindex="-1"]',
            ),
        )[0] || null
      );
    }
    attributeChangedCallback(e, t, s) {
      switch (e) {
        case "open":
          (t === null && s === ""
            ? (this.closeSiblings &&
                this.siblingsAccordions &&
                this.closeAccordions(),
              this.classList.add("is-visible"),
              this.$handles.forEach((i) => {
                i &&
                  i.hasAttribute("aria-expanded") &&
                  i.setAttribute("aria-expanded", "true");
              }),
              this.followFocus &&
                setTimeout(() => {
                  this.open &&
                    this.firstFocusableElement &&
                    this.firstFocusableElement.focus({ preventScroll: !0 });
                }, 50))
            : s === null &&
              (this.classList.remove("is-visible"),
              this.$handles.forEach((i) => {
                i &&
                  i.hasAttribute("aria-expanded") &&
                  i.setAttribute("aria-expanded", "false");
              }),
              this.followFocus &&
                setTimeout(() => {
                  !this.open &&
                    this.$handle &&
                    this.$handle.focus({ preventScroll: !0 });
                }, 50)),
            ((t === null && s === "") || s === null) &&
              this.dispatchEvent(new CustomEvent("toggle", { bubbles: !0 })));
          break;
      }
    }
    toggleHandler(e) {
      e.target.closest(this.selector.handle) &&
        (e.preventDefault(),
        e.target.closest(this.selector.handle).closest(this.localName) ===
          this && (this.open = !this.open));
    }
    closeAccordions() {
      this.siblingsAccordions.forEach((e) => {
        e !== this && e.open && (e.open = !1);
      });
    }
  },
  g = class extends HTMLElement {
    constructor() {
      super();
    }
    static get observedAttributes() {
      return ["open"];
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(e) {
      e ? this.setAttribute("open", "") : this.removeAttribute("open");
    }
    get name() {
      return this.dataset.name;
    }
    set initFocusTrap(e) {
      this.focusTrap = K(this, {
        fallbackFocus: this,
        initialFocus: this.initialFocus,
        setReturnFocus: () =>
          this.shouldCloseOnOutsideClick
            ? this.contains(document.activeElement) ||
              document.activeElement === document.body
              ? e
              : document.activeElement
            : e,
        allowOutsideClick: !0,
        clickOutsideDeactivates: (t) =>
          this.shouldCloseOnOutsideClick
            ? t.type !== "touchstart" && !t.target.closest(this.openerPattern)
            : !1,
        preventScroll: !0,
        onDeactivate: () => (this.open = !1),
      });
    }
    get activateFocusTrapOptions() {
      return null;
    }
    get deactivateFocusTrapOptions() {
      return null;
    }
    get initialFocusSelector() {
      return (
        this.dataset.initialFocusSelector &&
        this.querySelector(this.dataset.initialFocusSelector)
      );
    }
    get initialFocus() {
      return window.Shopify.designMode && !document.hasFocus()
        ? !1
        : this.initialFocusSelector || void 0;
    }
    get shouldCloseOnOutsideClick() {
      return !1;
    }
    get inertAttributeOnClose() {
      return !0;
    }
    get activeElement() {
      return this.originOpener || document.activeElement;
    }
    get openerPattern() {
      return '[is][data-type="'
        .concat(this.localName, '"]')
        .concat(this.name ? '[data-type-name="' + this.name + '"]' : "");
    }
    disconnectedCallback() {
      this.focusTrap &&
        this.focusTrap.deactivate(this.deactivateFocusTrapOptions);
    }
    attributeChangedCallback(e, t, s) {
      switch (e) {
        case "open":
          (t === null && s === ""
            ? ((this.initFocusTrap = this.activeElement),
              this.originOpener &&
                this.originOpener.hasAttribute("aria-expanded") &&
                this.originOpener.setAttribute("aria-expanded", "true"),
              this.inertAttributeOnClose && this.removeAttribute("inert"),
              setTimeout(() => {
                this.open &&
                  this.focusTrap.activate(this.activateFocusTrapOptions);
              }, 50))
            : s === null &&
              (this.originOpener &&
                this.originOpener.hasAttribute("aria-expanded") &&
                this.originOpener.setAttribute("aria-expanded", "false"),
              (this.originOpener = null),
              this.inertAttributeOnClose && this.setAttribute("inert", ""),
              this.focusTrap.deactivate(this.deactivateFocusTrapOptions)),
            ((t === null && s === "") || s === null) &&
              this.dispatchEvent(new CustomEvent("toggle", { bubbles: !0 })));
          break;
      }
    }
  },
  pe = class extends g {
    constructor() {
      (super(),
        (this.selector = { handle: ".u-dropdown-handle" }),
        (this.$handle = this.querySelector(this.selector.handle)),
        this.addEventListener("click", this.toggleHandler.bind(this)));
    }
    get shouldCloseOnOutsideClick() {
      return !0;
    }
    get inertAttributeOnClose() {
      return !1;
    }
    attributeChangedCallback(e, t, s) {
      switch ((super.attributeChangedCallback(e, t, s), e)) {
        case "open":
          t === null && s === ""
            ? (this.classList.add("is-visible"),
              this.$handle &&
                this.$handle.hasAttribute("aria-expanded") &&
                this.$handle.setAttribute("aria-expanded", "true"))
            : s === null &&
              (this.classList.remove("is-visible"),
              this.$handle &&
                this.$handle.hasAttribute("aria-expanded") &&
                this.$handle.setAttribute("aria-expanded", "false"));
          break;
      }
    }
    toggleHandler(e) {
      e.target.closest(this.selector.handle) &&
        (e.preventDefault(),
        (this.originOpener = this.open
          ? this.originOpener
          : e.target.closest(this.selector.handle)),
        (this.open = !this.open));
    }
  },
  L = () =>
    (document.querySelector("u-header") &&
      document.querySelector("u-header").offsetHeight) ||
    0,
  me = class extends HTMLAnchorElement {
    constructor() {
      (super(),
        this.addEventListener("click", this.anchorToHandler.bind(this)));
    }
    get targetedElement() {
      return (
        (this.getAttribute("href") &&
          this.getAttribute("href").startsWith("#") &&
          document.querySelector(this.getAttribute("href"))) ||
        null
      );
    }
    get gap() {
      return L() + this.extraGap;
    }
    get extraGap() {
      let e = 30;
      return (
        isNaN(parseInt(this.dataset.extraGap))
          ? this.dataset.extraGap &&
            document.querySelector(this.dataset.extraGap) &&
            (e = document.querySelector(this.dataset.extraGap).offsetHeight)
          : (e = parseInt(this.dataset.extraGap)),
        e
      );
    }
    get updateHash() {
      return this.dataset.updateHash === "true";
    }
    anchorToHandler(e) {
      if (
        (e.preventDefault(),
        this.targetedElement &&
          (window.scrollTo({
            top: parseInt(
              this.targetedElement.getBoundingClientRect().top +
                window.scrollY -
                this.gap,
            ),
            behavior: "smooth",
          }),
          setTimeout(() => {
            this.targetedElement.focus({ preventScroll: !0 });
          }, 50)),
        this.targetedElement && this.updateHash)
      ) {
        const t = new URL(this.getAttribute("href"), window.location.href);
        history.replaceState({ path: t.toString() }, null, t.toString());
      }
    }
  },
  fe = class extends HTMLUListElement {
    constructor() {
      super();
    }
    get count() {
      return this.querySelectorAll("li").length;
    }
    get interval() {
      return parseInt(this.dataset.interval) &&
        parseInt(this.dataset.interval) >= 1e3
        ? parseInt(this.dataset.interval)
        : 4500;
    }
    connectedCallback() {
      this.count > 1 &&
        ((this.activeIndex = 0),
        (this.cycle = setInterval(() => this.loopItems(), this.interval)));
    }
    disconnectedCallback() {
      this.cycle && clearInterval(this.cycle);
    }
    loopItems() {
      const e = this.querySelector("li.is-active");
      ([].slice.call(e.parentNode.children).indexOf(e) === this.count - 1
        ? (this.activeIndex = 0)
        : this.activeIndex++,
        e.classList.remove("is-active"),
        this.querySelectorAll("li")[this.activeIndex].classList.add(
          "is-active",
        ));
    }
  },
  ge = class extends HTMLElement {
    constructor() {
      (super(),
        (this.selector = {
          input: ".u-quantity-switcher-input",
          minus: ".u-quantity-switcher-minus",
          plus: ".u-quantity-switcher-plus",
        }),
        (this.$input = this.querySelector(this.selector.input)),
        (this.$minus = this.querySelector(this.selector.minus)),
        (this.$plus = this.querySelector(this.selector.plus)),
        this.$input &&
          (this.$input.addEventListener(
            "change",
            this.checkQuantity.bind(this),
          ),
          this.$input.addEventListener("input", this.checkQuantity.bind(this))),
        this.$input &&
          this.$minus &&
          this.$minus.addEventListener(
            "click",
            this.decreaseQuantity.bind(this),
          ),
        this.$input &&
          this.$plus &&
          this.$plus.addEventListener(
            "click",
            this.increaseQuantity.bind(this),
          ));
    }
    get inputValue() {
      return (this.$input && parseInt(this.$input.value)) || 0;
    }
    set inputValue(e) {
      this.$input.value = e;
    }
    checkQuantity(e) {
      (this.$minus.removeAttribute("disabled"),
        this.$minus.classList.remove("is-disabled"),
        this.$plus.classList.remove("is-disabled"),
        this.$plus.removeAttribute("disabled"),
        e.type === "change" &&
          !Number.isInteger(this.inputValue) &&
          (this.inputValue = 1),
        this.$input.min &&
          this.$input.min > this.inputValue - 1 &&
          ((this.inputValue = this.$input.min),
          this.$minus.classList.add("is-disabled"),
          this.$minus.setAttribute("disabled", "disabled")),
        this.$input.max &&
          this.$input.max < this.inputValue + 1 &&
          ((this.inputValue = this.$input.max),
          this.$plus.classList.add("is-disabled"),
          this.$plus.setAttribute("disabled", "disabled")));
    }
    decreaseQuantity(e) {
      (e.preventDefault(),
        (this.inputValue = this.inputValue - 1),
        this.$input.dispatchEvent(new Event("change", { bubbles: !0 })));
    }
    increaseQuantity(e) {
      (e.preventDefault(),
        (this.inputValue = this.inputValue + 1),
        this.$input.dispatchEvent(new Event("change", { bubbles: !0 })));
    }
  };
function P(e, t = 25) {
  let s = null,
    i = null;
  const n = (r) => {
    ((i = r),
      !s &&
        (e(i),
        (i = null),
        (s = setTimeout(() => {
          ((s = null), i && n(i));
        }, t))));
  };
  return n;
}
const ve = class extends HTMLBodyElement {
    constructor() {
      (super(),
        (this.lastScrollY = window.scrollY),
        (this.scrollHandlerListener = P(this.scrollHandler.bind(this), 50)));
    }
    connectedCallback() {
      window.addEventListener("scroll", this.scrollHandlerListener);
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this.scrollHandlerListener);
    }
    scrollHandler() {
      ((this.currentScrollY = window.scrollY),
        (this.currentScrollYMax =
          document.documentElement.scrollHeight - window.innerHeight),
        this.currentScrollY > this.lastScrollY &&
        !this.classList.contains("has-scrolled-down")
          ? (this.classList.remove("has-scrolled-up"),
            this.classList.add("has-scrolled-down"))
          : this.currentScrollY < this.lastScrollY &&
            !this.classList.contains("has-scrolled-up") &&
            (this.classList.remove("has-scrolled-down"),
            this.classList.add("has-scrolled-up")),
        (this.lastScrollY = Math.min(
          Math.max(this.currentScrollY, 0),
          this.currentScrollYMax,
        )));
    }
  },
  Ee = class extends HTMLElement {
    constructor() {
      (super(),
        (this.lastScrollY = window.scrollY),
        (this.currentTop = 0),
        (this.hasPendingRaf = !1),
        (this.checkPositionListener = this.checkPosition.bind(this)),
        (this.updateStickedClassListener = this.updateStickedClass.bind(this)));
    }
    get gap() {
      let e = L();
      return (
        isNaN(parseInt(this.dataset.gap))
          ? this.dataset.gap &&
            document.querySelector(this.dataset.gap) &&
            (e = document.querySelector(this.dataset.gap).offsetHeight)
          : (e = parseInt(this.dataset.gap)),
        e
      );
    }
    get extraOffsetTop() {
      return parseInt(this.dataset.offsetTop) || 0;
    }
    get extraOffsetBottom() {
      return parseInt(this.dataset.offsetBottom) || 0;
    }
    get initialTopOffset() {
      return this.gap + this.extraOffsetTop;
    }
    connectedCallback() {
      (this.checkPosition(),
        this.updateStickedClass(),
        window.addEventListener("scroll", this.checkPositionListener),
        window.addEventListener("resize", this.checkPositionListener),
        window.addEventListener("scroll", this.updateStickedClassListener),
        window.addEventListener("resize", this.updateStickedClassListener));
    }
    disconnectedCallback() {
      (window.removeEventListener("scroll", this.checkPositionListener),
        window.removeEventListener("resize", this.checkPositionListener),
        window.removeEventListener("scroll", this.updateStickedClassListener),
        window.removeEventListener("resize", this.updateStickedClassListener));
    }
    checkPosition() {
      this.hasPendingRaf ||
        !getComputedStyle(this).position.includes("sticky") ||
        ((this.hasPendingRaf = !0),
        requestAnimationFrame(() => {
          const e =
              parseInt(
                this.getBoundingClientRect().top +
                  window.scrollY -
                  this.offsetTop,
              ) + this.initialTopOffset,
            t = this.offsetHeight + this.extraOffsetBottom - window.innerHeight;
          (window.scrollY < this.lastScrollY
            ? (this.currentTop -= window.scrollY - this.lastScrollY)
            : (this.currentTop += this.lastScrollY - window.scrollY),
            (this.currentTop = Math.min(
              Math.max(this.currentTop, -t),
              e,
              this.initialTopOffset,
            )),
            (this.lastScrollY = window.scrollY),
            (this.style.top = "".concat(this.currentTop, "px")),
            (this.hasPendingRaf = !1));
        }));
    }
    updateStickedClass() {
      getComputedStyle(this).position.includes("sticky") &&
      this.getBoundingClientRect().top <= this.initialTopOffset
        ? this.classList.add("is-sticked")
        : this.classList.remove("is-sticked");
    }
  },
  be = class extends HTMLElement {
    constructor() {
      (super(),
        (this.selector = { toggle: ".u-video-toggle", mute: ".u-video-mute" }),
        (this.$video = this.querySelector("video")),
        this.$video &&
          (this.addEventListener("click", this.toggleHandler.bind(this)),
          this.$video.addEventListener(
            "playing",
            this.playingHandler.bind(this),
          ),
          this.$video.addEventListener(
            "waiting",
            this.waitingHandler.bind(this),
          ),
          this.$video.addEventListener("pause", this.pauseHandler.bind(this)),
          this.$video.addEventListener("ended", this.endedHandler.bind(this)),
          this.$video.addEventListener(
            "contextmenu",
            this.contextmenuHandler.bind(this),
          ),
          this.$video.addEventListener(
            "volumechange",
            this.volumeChangeHandler.bind(this),
          ),
          this.$video.paused === !0
            ? this.classList.add("is-paused")
            : this.classList.add("is-playing"),
          this.$video.controls && this.classList.add("has-controls"),
          this.$video.muted
            ? this.classList.add("is-muted")
            : this.classList.add("is-unmuted")));
    }
    get currentPlayingVideos() {
      return Array.from(document.querySelectorAll(this.localName))
        .filter((e) => e !== this && !e.$video.loop && !e.$video.paused)
        .map((e) => e.$video);
    }
    cleanClasses() {
      this.className = this.className
        .split(" ")
        .filter((e) => !e.startsWith("is-"))
        .join(" ")
        .trim();
    }
    toggleHandler(e) {
      if (e.target.closest(this.selector.mute)) {
        this.$video.muted = !this.$video.muted;
        return;
      }
      e.target.closest(this.selector.toggle) &&
        (this.cleanClasses(),
        this.$video.paused === !0 ? this.$video.play() : this.$video.pause());
    }
    playingHandler() {
      (this.cleanClasses(),
        this.classList.add("is-playing"),
        this.$video.muted
          ? this.classList.add("is-muted")
          : this.classList.add("is-unmuted"),
        this.$video.loop ||
          this.currentPlayingVideos.forEach((e) => {
            e.pause();
          }));
    }
    waitingHandler() {
      (this.cleanClasses(),
        this.classList.add("is-waiting"),
        this.$video.muted
          ? this.classList.add("is-muted")
          : this.classList.add("is-unmuted"));
    }
    pauseHandler() {
      (this.cleanClasses(),
        this.classList.add("is-paused"),
        this.$video.muted
          ? this.classList.add("is-muted")
          : this.classList.add("is-unmuted"));
    }
    endedHandler() {
      (this.cleanClasses(),
        this.classList.add("is-ended"),
        this.$video.muted
          ? this.classList.add("is-muted")
          : this.classList.add("is-unmuted"));
    }
    volumeChangeHandler() {
      this.classList.toggle("is-muted", this.$video.muted);
      this.classList.toggle("is-unmuted", !this.$video.muted);
    }
    contextmenuHandler(e) {
      e.preventDefault();
    }
  },
  U = class extends HTMLFormElement {
    constructor() {
      (super(),
        (this.selector = {
          field: ".u-form-field",
          inputs: 'input:not([type="hidden"]), textarea, select',
        }),
        this.addEventListener("submit", this.submitForm.bind(this)),
        this.addEventListener("input", this.fieldHandler.bind(this)),
        this.addEventListener("focusin", this.fieldHandler.bind(this)),
        this.addEventListener("focusout", this.fieldHandler.bind(this)),
        this.addEventListener(
          "form:field:check-value",
          this.fieldHandler.bind(this),
        ));
    }
    set resetPristine(e = "reset") {
      this.pristine &&
        (this.pristine.reset(),
        e === "reinit" &&
          (this.pristine.destroy(),
          (this.pristine = new w(this, this.pristineConfig))),
        this.checkFieldsValues());
    }
    get pristineConfig() {
      return {
        classTo: this.selector.field.replace(".", ""),
        errorClass: "has-error",
        successClass: "has-success",
        errorTextTag: "p",
        errorTextParent: this.selector.field.replace(".", ""),
      };
    }
    connectedCallback() {
      ((this.pristine = new w(this, this.pristineConfig)),
        this.checkFieldsValues());
    }
    disconnectedCallback() {
      this.pristine.destroy();
    }
    fieldHandler(e) {
      if (e.target.closest(this.selector.field)) {
        const t = e.target.closest(this.selector.inputs);
        (t &&
          (e.type === "input" || e.type === "form:field:check-value") &&
          (t.value
            ? t.closest(this.selector.field).classList.add("is-filled")
            : t.closest(this.selector.field).classList.remove("is-filled")),
          t &&
            e.type === "focusin" &&
            t.closest(this.selector.field).classList.add("has-focus"),
          t &&
            e.type === "focusout" &&
            t.closest(this.selector.field).classList.remove("has-focus"));
      }
    }
    checkFieldsValues() {
      this.querySelectorAll(this.selector.inputs).forEach((e) => {
        e.dispatchEvent(
          new CustomEvent("form:field:check-value", { bubbles: !0 }),
        );
      });
    }
    submitForm(e) {
      if (
        (this.pristine.validate() === !1 &&
          (e.stopImmediatePropagation(), e.preventDefault()),
        this.hasAttribute("action") || e.preventDefault(),
        this.pristine.validate() === !0)
      )
        this.dispatchEvent(
          new CustomEvent("form:pristine:validate", { bubbles: !0 }),
        );
      else if (this.pristine.validate() === !1) {
        const t = this.pristine.fields.find((s) => s.errors.length > 0);
        if (
          (t.input.type === "radio" || t.input.type === "checkbox") &&
          t.input.closest(this.selector.field)
        ) {
          const s = t.input.closest(this.selector.field);
          (s.setAttribute("tabindex", "-1"),
            s.focus(),
            setTimeout(() => {
              (s.removeAttribute("tabindex"), t.input.focus());
            }, 0));
        } else t && t.input.focus();
      }
    }
  },
  we = (e, t = "all") => {
    let s = e.items;
    return (
      t === "physical" && (s = s.filter((i) => i.requires_shipping === !0)),
      !!s.length
    );
  },
  z = (e) => {
    let boxItemCount = 0;
    e.items.forEach((i) => {
      if (i.properties['_box_item']) {
        boxItemCount += i.quantity;
      }
    });
    return e.item_count - boxItemCount;
  },
  N = (e, t) => {
    const s = t ? Object.values(t).find((i) => i.sections) : null;
    return s && e ? s.sections[e] : null;
  },
  u = class extends HTMLElement {
    constructor() {
      (super(),
        (this.addSuccessEventListener = this.addSuccessEvent.bind(this)),
        (this.addErrorEventListener = this.addErrorEvent.bind(this)),
        (this.removeSuccessEventListener = this.removeSuccessEvent.bind(this)),
        (this.removeErrorEventListener = this.removeErrorEvent.bind(this)),
        (this.updateSuccessEventListener = this.updateSuccessEvent.bind(this)),
        (this.updateErrorEventListener = this.updateErrorEvent.bind(this)),
        (this.refreshSuccessEventListener =
          this.refreshSuccessEvent.bind(this)));
    }
    connectedCallback() {
      (document.addEventListener(
        "uniqart:add:success",
        this.addSuccessEventListener,
      ),
        document.addEventListener(
          "uniqart:add:error",
          this.addErrorEventListener,
        ),
        document.addEventListener(
          "uniqart:add[]:success",
          this.addSuccessEventListener,
        ),
        document.addEventListener(
          "uniqart:add[]:error",
          this.addErrorEventListener,
        ),
        document.addEventListener(
          "uniqart:remove[]:success",
          this.removeSuccessEventListener,
        ),
        document.addEventListener(
          "uniqart:remove[]:error",
          this.removeErrorEventListener,
        ),
        document.addEventListener(
          "uniqart:update:success",
          this.updateSuccessEventListener,
        ),
        document.addEventListener(
          "uniqart:update:error",
          this.updateErrorEventListener,
        ),
        document.addEventListener(
          "uniqart:refresh:success",
          this.refreshSuccessEventListener,
        ));
    }
    disconnectedCallback() {
      (document.removeEventListener(
        "uniqart:add:success",
        this.addSuccessEventListener,
      ),
        document.removeEventListener(
          "uniqart:add:error",
          this.addErrorEventListener,
        ),
        document.removeEventListener(
          "uniqart:add[]:success",
          this.addSuccessEventListener,
        ),
        document.removeEventListener(
          "uniqart:add[]:error",
          this.addErrorEventListener,
        ),
        document.removeEventListener(
          "uniqart:remove[]:success",
          this.removeSuccessEventListener,
        ),
        document.removeEventListener(
          "uniqart:remove[]:error",
          this.removeErrorEventListener,
        ),
        document.removeEventListener(
          "uniqart:update:success",
          this.updateSuccessEventListener,
        ),
        document.removeEventListener(
          "uniqart:update:error",
          this.updateErrorEventListener,
        ),
        document.removeEventListener(
          "uniqart:refresh:success",
          this.refreshSuccessEventListener,
        ));
    }
    addSuccessEvent(e) {
      this.renderContent(e.detail);
    }
    addErrorEvent(e) {}
    removeSuccessEvent(e) {
      this.renderContent(e.detail);
    }
    removeErrorEvent(e) {}
    updateSuccessEvent(e) {
      this.renderContent(e.detail);
    }
    updateErrorEvent(e) {}
    refreshSuccessEvent(e) {
      this.renderContent(e.detail);
    }
    renderContent(e) {}
  },
  I = class extends u {
    constructor() {
      super();
    }
    get sectionId() {
      return this.dataset.sectionId;
    }
    async renderContent(e) {
      if (N(this.sectionId, e)) {
        const t = new DOMParser().parseFromString(
          N(this.sectionId, e),
          "text/html",
        ).body.firstElementChild;
        this.innerHTML = t.innerHTML;
      } else if (this.sectionId) {
        (this.classList.add("is-pending"),
          this.firstElementChild || this.classList.add("is-empty"));
        const t = await fetch(
            ""
              .concat(theme.routes.rootPath, "?section_id=")
              .concat(this.sectionId),
          ),
          s = await t.text(),
          i = new DOMParser().parseFromString(s, "text/html").body;
        if (t.ok === !1)
          throw new Error(
            "Something went wrong in CartSection.renderContent() (".concat(
              this.localName,
              ")",
            ),
          );
        ((this.innerHTML = i.firstElementChild.innerHTML),
          this.classList.remove("is-pending", "is-empty"));
      }
      this.dispatchEvent(
        new CustomEvent("cart-section:render-content:complete", {
          bubbles: !0,
        }),
      );
    }
  },
  ye = class extends u {
    constructor() {
      super();
    }
    renderContent(e) {
      const t = z(e.cart);

      let clearCart = true;
      const cartIsEmpty = e.cart.item_count === 0;
      e.cart.items.forEach((i) => {
        if (!i.properties['_box_item']) {
          clearCart = false;
        }
      });
      
      if (clearCart && !cartIsEmpty) {
        fetch(`${theme.routes.rootPath}cart/clear`)
        .then(() => {
          window.location.reload();
        })
      }

      ((this.innerHTML =
        t > 0 ? '<span aria-hidden="true">'.concat(t, "</span>") : ""),
        (this.innerHTML += '<span class="sr-only">'
          .concat(t, " ")
          .concat(
            t > 1 ? theme.strings.cart.products : theme.strings.cart.product,
            "</span>",
          )));
    }
  },
  Le = class extends u {
    constructor() {
      super();
    }
    renderContent(e) {
      const t = z(e.cart);
      this.innerHTML = ""
        .concat(t, " ")
        .concat(
          t > 1 ? theme.strings.cart.products : theme.strings.cart.product,
        );
    }
  },
  Se = class extends u {
    constructor() {
      super();
    }
    get property() {
      return this.dataset.property;
    }
    renderContent(e) {
      this.property &&
        (this.innerHTML =
          (e.cart[this.property] &&
            typeof e.cart[this.property] == "number" &&
            f(e.cart[this.property])) ||
          "");
    }
  },
  Ce = class extends u {
    constructor() {
      super();
    }
    renderContent(e) {
      (e.cart.total_discount > 0
        ? this.classList.add("is-visible")
        : this.classList.remove("is-visible"),
        ((this.querySelector("strong") || this).innerHTML = "-".concat(
          f(e.cart.total_discount),
        )));
    }
  },
  ke = class extends u {
    constructor() {
      (super(),
        (this.selector = {
          message: ".u-cart-delivery-message",
          progress: ".u-cart-delivery-progress",
        }),
        (this.rateAttempts = 0));
    }
    connectedCallback() {
      super.connectedCallback && super.connectedCallback();

      // Listen for when the cart drawer opens
      const cartDrawer = document.querySelector('u-drawer[data-name="cart"]');
      if (cartDrawer) {
        this.drawerObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "open"
            ) {
              if (cartDrawer.hasAttribute("open")) {
                // When drawer opens, wait for currency rate and trigger refresh
                this.waitForRateAndRefresh();
              }
            }
          });
        });
        this.drawerObserver.observe(cartDrawer, { attributes: true });
      }
    }
    disconnectedCallback() {
      super.disconnectedCallback && super.disconnectedCallback();
      if (this.drawerObserver) {
        this.drawerObserver.disconnect();
      }
    }
    waitForRateAndRefresh() {
      // Wait for currency rate to be available, then trigger cart refresh
      if (window.Shopify?.currency?.rate) {
        // Rate is available, trigger a cart refresh event manually
        W(); // This is the refreshCart function
      } else {
        // Wait a bit and try again
        let attempts = 0;
        const checkRate = setInterval(() => {
          if (window.Shopify?.currency?.rate || attempts >= 20) {
            clearInterval(checkRate);
            if (window.Shopify?.currency?.rate) {
              W(); // Refresh cart once rate is available
            }
          }
          attempts++;
        }, 100);
      }
    }
    renderContent(e) {
      we(e.cart, "physical") === !0
        ? this.classList.add("is-visible")
        : this.classList.remove("is-visible");

      // Get EUR threshold from data attribute every time
      const thresholdEur = parseFloat(this.dataset.thresholdEur);
      const messageTemplate = this.dataset.messageTemplate;
      const successMessage = this.dataset.successMessage;

      // Always try to convert using window.Shopify.currency.rate
      let deliveryThreshold = theme.settings.cartDelivery.amount;

      // Check if we have both threshold and rate
      if (thresholdEur) {
        if (window.Shopify?.currency?.rate) {
          const rate = parseFloat(window.Shopify.currency.rate);
          deliveryThreshold = Math.round(thresholdEur * 100 * rate);
        } else if (
          window.Shopify?.currency?.active &&
          window.Shopify.currency.active !== "EUR"
        ) {
          // If no rate but currency is not EUR, wait a bit and try again
          if (this.rateAttempts < 10) {
            this.rateAttempts++;
            setTimeout(() => this.renderContent(e), 200);
            return;
          } else {
            // Fallback: use EUR amount if rate never loads
            deliveryThreshold = Math.round(thresholdEur * 100);
          }
        } else {
          // EUR currency, no conversion needed
          deliveryThreshold = Math.round(thresholdEur * 100);
        }
      }

      let t = e.cart.items
        .filter((r) => r.requires_shipping === !0 && !r.properties['_box_item'])
        .map((r) => r.original_line_price)
        .reduce((r, a) => r + a, 0);
      // t = t - e.cart.total_discount;
      const s = deliveryThreshold - t;
      let i = (t / deliveryThreshold) * 100,
        n = (messageTemplate || theme.settings.cartDelivery.message).replace(
          "[amount]",
          "".concat(f(s)),
        );
      (deliveryThreshold <= t &&
        ((i = 100),
        (n = successMessage || theme.settings.cartDelivery.success)),
        this.querySelector(this.selector.message) &&
          (this.querySelector(this.selector.message).innerHTML = n),
        this.querySelector(this.selector.progress) &&
          (this.querySelector(this.selector.progress).style =
            "--current-progress: ".concat(i, "%;")));
    }
  },
  qe = class extends I {
    constructor() {
      (super(),
        (this.requestStartedEventListener =
          this.requestStartedEvent.bind(this)));
    }
    get focusTo() {
      return (
        (this.focusToSelector && this.querySelector(this.focusToSelector)) ||
        null
      );
    }
    connectedCallback() {
      (document.addEventListener(
        "uniqart:request:started",
        this.requestStartedEventListener,
      ),
        super.connectedCallback());
    }
    disconnectedCallback() {
      (document.removeEventListener(
        "uniqart:request:started",
        this.requestStartedEventListener,
      ),
        super.disconnectedCallback());
    }
    requestStartedEvent(e) {
      this.focusToSelector =
        (this.contains(document.activeElement) &&
          document.activeElement.dataset.focusTo) ||
        null;
    }
    updateErrorEvent(e) {
      this.renderContent();
    }
    async renderContent(e) {
      (await super.renderContent(e), this.tryFocus());
    }
    tryFocus() {
      this.focusTo && this.focusTo.focus({ preventScroll: !0 });
    }
  },
  j = class extends u {
    constructor() {
      (super(),
        (this.selector = {
          input: ".u-cart-line-input",
          remove: ".u-cart-line-remove",
        }),
        this.addEventListener("change", this.updateQuantity.bind(this)),
        this.addEventListener("focusout", this.updateQuantity.bind(this)),
        this.addEventListener("click", this.removeLine.bind(this)));
    }
    updateQuantity(e) {
      if (e.target.closest(this.selector.input)) {
        const t = e.target.closest(this.selector.input).dataset.key,
          s = Number.isInteger(
            parseInt(e.target.closest(this.selector.input).value),
          )
            ? parseInt(e.target.closest(this.selector.input).value)
            : 1;
        if (
          e.type === "focusout" &&
          (e.target.closest(this.selector.input).defaultValue === void 0 ||
            e.target.closest(this.selector.input).defaultValue ===
              e.target.closest(this.selector.input).value)
        )
          return;
        t &&
          !this.classList.contains("is-pending") &&
          (this.classList.add("is-pending"),
          _({
            key: t,
            quantity: s,
            sections_url:
              s > 0 &&
              ""
                .concat(theme.routes.rootPath, "variants/")
                .concat(t.split(":")[0]),
          }));
      }
    }
    removeLine(e) {
      if (e.target.closest(this.selector.remove)) {
        const t = e.target.closest(this.selector.remove).dataset.key;
        t &&
          !this.classList.contains("is-pending") &&
          (this.classList.add("is-pending"), _({ key: t, quantity: 0 }));
      }
    }
  },
  xe = class extends j {
    constructor() {
      (super(), (this.selector = { remove: ".u-cart-line-box-remove" }));
    }
    async removeLine(e) {
      if (e.target.closest(this.selector.remove)) {
        const t = e.target.closest(this.selector.remove).dataset.key,
          s = e.target.closest(this.selector.remove).dataset.uniqueId,
          i = e.target
            .closest(this.selector.remove)
            .dataset.boxItemsKeys.split(",");
        if (!t || !s || !i) return;
        await X({ items: i });
      }
    }
  },
  $e = class extends I {
    constructor() {
      super();
    }
    connectedCallback() {
      (document.addEventListener(
        "uniqart:add:success",
        this.addSuccessEventListener,
      ),
        document.addEventListener(
          "uniqart:add[]:success",
          this.addSuccessEventListener,
        ));
    }
  },
  Te = class extends I {
    constructor() {
      super();
    }
    get renderContentOnLoad() {
      return this.dataset.renderContentOnLoad === "true";
    }
    connectedCallback() {
      (document.addEventListener(
        "uniqart:add:success",
        this.addSuccessEventListener,
      ),
        document.addEventListener(
          "uniqart:update:success",
          this.updateSuccessEventListener,
        ),
        document.addEventListener(
          "uniqart:refresh:success",
          this.refreshSuccessEventListener,
        ),
        this.renderContentOnLoad && this.renderContent());
    }
  },
  Pe = class extends u {
    constructor() {
      (super(),
        (this.visibleTimer = null),
        (this.noficationTimer = null),
        (this.cleanTimer = null),
        (this.copyNotification = null));
    }
    disconnectedCallback() {
      (super.disconnectedCallback(), this.clearTimers());
    }
    addErrorEvent(e) {
      this.renderContent(e.detail);
    }
    updateErrorEvent(e) {
      this.renderContent(e.detail);
    }
    refreshSuccessEvent() {}
    cleanNotification(e) {
      ((e.innerHTML = ""),
        this.copyNotification &&
          (this.copyNotification.remove(), (this.copyNotification = null)));
    }
    clearTimers() {
      (clearTimeout(this.visibleTimer),
        clearTimeout(this.noficationTimer),
        clearTimeout(this.cleanTimer));
    }
    renderContent(e) {
      const t =
        e.status === 422
          ? e.description && typeof e.description == "string"
            ? e.description
            : e.message
          : null;
      if (
        (this.clearTimers(),
        this.classList.remove("is-visible"),
        this.cleanNotification(this),
        t)
      ) {
        const s = Array.from(
          document.querySelectorAll(
            '[role*="dialog"][aria-modal="true"][open]',
          ),
        ).find((n) => n.focusTrap && n.focusTrap.active && !n.focusTrap.paused);
        s &&
          ((this.copyNotification = this.cloneNode(!0)),
          s.prepend(this.copyNotification));
        const i = this.copyNotification || this;
        ((this.visibleTimer = setTimeout(() => {
          ((i.innerHTML =
            '<p class="notification__message" aria-live="assertive" aria-atomic="true">'.concat(
              t,
              "</p>",
            )),
            i.classList.add("is-visible"));
        }, 200)),
          (this.noficationTimer = setTimeout(() => {
            (i.classList.remove("is-visible"),
              (this.cleanTimer = setTimeout(() => {
                this.cleanNotification(i);
              }, 1e3)));
          }, 5e3)));
      }
    }
  },
  Ie = class extends HTMLButtonElement {
    constructor() {
      (super(), this.addEventListener("click", this.addToCart.bind(this)));
    }
    get id() {
      return this.dataset.id;
    }
    get quantity() {
      return this.dataset.quantity ? parseInt(this.dataset.quantity) : 1;
    }
    addToCart(e) {
      (e.preventDefault(),
        !(
          this.hasAttribute("disabled") ||
          this.classList.contains("is-progress") ||
          this.classList.contains("is-success")
        ) &&
          this.id &&
          this.quantity &&
          (this.classList.add("is-progress"),
          Z({
            id: this.id,
            quantity: this.quantity,
            sections_url: ""
              .concat(theme.routes.rootPath, "variants/")
              .concat(this.id),
          })));
    }
  },
  Y = class extends HTMLElement {
    constructor() {
      super();
    }
    get currentProduct() {
      return this.dataset.product;
    }
    get sectionId() {
      return this.dataset.sectionId;
    }
    get limit() {
      return parseInt(this.dataset.limit) || 6;
    }
    get cookieName() {
      return "products_history_".concat(theme.settings.shopName);
    }
    get cookieValue() {
      return B.get(this.cookieName);
    }
    set cookie(e) {
      B.set(this.cookieName, e, { sameSite: "None", secure: !0, expires: 30 });
    }
    get searchQuery() {
      const e = [];
      if (this.cookieValue && this.cookieValue.split(",").length >= 1) {
        let t = 0;
        for (let s of this.cookieValue.split(","))
          this.currentProduct !== s &&
            t < this.limit &&
            (e.push("id:".concat(s)), (t = t + 1));
      }
      return e.join(" OR ");
    }
    connectedCallback() {
      if (this.currentProduct && this.cookieValue) {
        const e = this.cookieValue.split(",");
        (e.indexOf(this.currentProduct) === -1 &&
          e.unshift(this.currentProduct),
          e.length > this.limit + 1 && e.pop(),
          e.toString() !== this.cookieValue && (this.cookie = e));
      } else this.currentProduct && (this.cookie = [this.currentProduct]);
      this.searchQuery &&
        this.cookieValue &&
        this.sectionId &&
        this.classList.contains("is-hidden") &&
        this.renderContent();
    }
    async renderContent() {
      const e = await fetch(
          ""
            .concat(theme.routes.searchUrl, "?type=product&q=")
            .concat(
              encodeURIComponent(this.searchQuery),
              "&options[unavailable_products]=show&section_id=",
            )
            .concat(this.sectionId),
        ),
        t = await e.text(),
        s = new DOMParser().parseFromString(t, "text/html").body;
      if (
        e.ok === !1 &&
        window.Shopify.designMode &&
        !window.Shopify.visualPreviewMode
      )
        return this.renderContent();
      if (e.ok === !1)
        throw new Error(
          "Something went wrong in RecentlyViewed.renderContent()",
        );
      this.querySelector(".swiper-wrapper").innerHTML = "";
      for (let i of this.cookieValue.split(","))
        s.querySelector(".swiper-wrapper") &&
          s.querySelector(
            '.product--cardteaser[data-product-id="'.concat(i, '"]'),
          ) &&
          this.querySelector(".swiper-wrapper").insertAdjacentHTML(
            "beforeend",
            s
              .querySelector(
                '.product--cardteaser[data-product-id="'.concat(i, '"]'),
              )
              .closest(".swiper-slide").outerHTML,
          );
      (this.querySelector(".product--cardteaser") &&
        this.classList.remove("is-hidden"),
        this.dispatchEvent(
          new CustomEvent("recently-viewed:render-content:complete", {
            bubbles: !0,
          }),
        ));
    }
  },
  Ae = class extends Y {
    constructor() {
      super();
    }
    get cookieName() {
      return "cart_products_history_".concat(theme.settings.shopName);
    }
    async renderContent() {
      const e = await fetch(
          ""
            .concat(theme.routes.searchUrl, "?type=product&q=")
            .concat(
              encodeURIComponent(this.searchQuery),
              "&options[unavailable_products]=show&section_id=",
            )
            .concat(this.sectionId),
        ),
        t = await e.text(),
        s = new DOMParser().parseFromString(t, "text/html").body;
      let i = 0;
      if (
        e.ok === !1 &&
        window.Shopify.designMode &&
        !window.Shopify.visualPreviewMode
      )
        return this.renderContent();
      if (e.ok === !1)
        throw new Error(
          "Something went wrong in RecentlyViewed.renderContent()",
        );
      (s.querySelectorAll(".product--teaser").forEach((n) => {
        i = i + 1;
      }),
        this.querySelector(".products") &&
          i < 4 &&
          (this.querySelector(".products").classList.add(
            "products--slider-" + i,
          ),
          this.querySelector(".products").classList.add(
            "products--slider-centered",
          )),
        (this.querySelector(".swiper-wrapper").innerHTML = ""));
      for (let n of this.cookieValue.split(","))
        s.querySelector(".swiper-wrapper") &&
          s.querySelector(
            '.product--teaser[data-product-id="'.concat(n, '"]'),
          ) &&
          this.querySelector(".swiper-wrapper").insertAdjacentHTML(
            "beforeend",
            s
              .querySelector(
                '.product--teaser[data-product-id="'.concat(n, '"]'),
              )
              .closest(".swiper-slide").outerHTML,
          );
      (this.querySelector(".product--teaser") &&
        this.classList.remove("is-hidden"),
        this.dispatchEvent(
          new CustomEvent("recently-viewed:render-content:complete", {
            bubbles: !0,
          }),
        ));
    }
  },
  He = class extends HTMLElement {
    constructor() {
      (super(),
        (this.stickyHandlerListener = P(this.stickyHandler.bind(this), 50)));
    }
    get headerElement() {
      return (this._headerElement =
        this._headerElement || this.closest(".header") || this.parentNode);
    }
    get heroElement() {
      return document.querySelector("u-hero");
    }
    get gap() {
      return parseInt(this.dataset.gap) || 0;
    }
    get isSticked() {
      return (
        window.scrollY >
        this.gap +
          (this.headerElement.previousElementSibling
            ? parseInt(
                this.headerElement.previousElementSibling.getBoundingClientRect()
                  .bottom + window.scrollY,
              )
            : this.headerElement.parentNode
              ? parseInt(
                  this.headerElement.parentNode.getBoundingClientRect().top +
                    window.scrollY,
                )
              : 0)
      );
    }
    connectedCallback() {
      this.headerElement &&
        (window.addEventListener("scroll", this.stickyHandlerListener),
        this.stickyHandler());
    }
    disconnectedCallback() {
      this.headerElement &&
        window.removeEventListener("scroll", this.stickyHandlerListener);
    }
    stickyHandler() {
      this.isSticked === !0
        ? this.headerElement.classList.add("is-sticked", "is-filled")
        : (this.headerElement.classList.remove("is-sticked"),
          this.headerElement.classList.contains("is-megarolled")
            ? this.headerElement.classList.add("is-filled")
            : this.headerElement.classList.remove("is-filled"));
    }
  },
  Me = class extends HTMLAnchorElement {
    constructor() {
      (super(),
        this.addEventListener("click", this.interceptLink.bind(this)),
        this.openingMode === "hover"
          ? (this.addEventListener("mouseover", this.toggleHandler.bind(this)),
            this.addEventListener("focusin", this.toggleHandler.bind(this)),
            this.addEventListener("focusout", this.focusOutHandler.bind(this)),
            this.addEventListener("touchstart", this.toggleHandler.bind(this), {
              passive: !1,
            }))
          : (this.addEventListener("click", this.toggleHandler.bind(this)),
            this.addEventListener("keydown", this.toggleHandler.bind(this))));
    }
    get megarollElement() {
      return this.nextElementSibling &&
        this.nextElementSibling.localName === "u-megaroll"
        ? this.nextElementSibling
        : null;
    }
    get openingMode() {
      return this.dataset.openingMode || "hover";
    }
    interceptLink(e) {
      this.getAttribute("href") &&
        this.getAttribute("href").endsWith("#") &&
        e.preventDefault();
    }
    toggleHandler(e) {
      this.megarollElement
        ? this.openingMode === "hover"
          ? this.hoverOpeningMode(e)
          : this.clickOpeningMode(e)
        : document.querySelectorAll("u-megaroll[open]").forEach((t) => {
            t.open = !1;
          });
    }
    clickOpeningMode(e) {
      (e.type === "click" || (e.type === "keydown" && e.code === "Space")) &&
        (e.preventDefault(),
        (this.megarollElement.openByHandle = !this.megarollElement.open),
        (this.megarollElement.open = !this.megarollElement.open));
    }
    hoverOpeningMode(e) {
      (e.type === "mouseover" ||
        e.type === "touchstart" ||
        (e.type === "focusin" &&
          !this.megarollElement.contains(e.relatedTarget) &&
          !this.contains(this.previousFocusedElement))) &&
        (e.type === "touchstart" &&
          e.cancelable &&
          !this.megarollElement.open &&
          (e.preventDefault(),
          this.addEventListener(
            "touchend",
            () => {
              this.focus({ preventScroll: !0 });
            },
            { once: !0, passive: !1 },
          )),
        this.dispatchMousedownEvent(),
        (this.megarollElement.openByHandle = !0),
        (this.megarollElement.open = !0));
    }
    dispatchMousedownEvent() {
      this.dispatchEvent(new MouseEvent("mousedown", { bubbles: !0 }));
    }
    focusOutHandler(e) {
      this.previousFocusedElement = document.activeElement;
    }
  },
  Oe = class extends HTMLElement {
    constructor() {
      (super(),
        (this.selector = { close: ".u-megaroll-close" }),
        (this.closeHandlerListener = this.closeHandler.bind(this)),
        this.addEventListener("click", this.closeHandler.bind(this)),
        this.addEventListener("focusout", this.closeHandler.bind(this)),
        window.Shopify.designMode &&
          (this.addEventListener(
            "shopify:block:select",
            () => (this.open = !0),
          ),
          this.addEventListener(
            "shopify:block:deselect",
            () => (this.open = !1),
          )));
    }
    static get observedAttributes() {
      return ["open"];
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(e) {
      e ? this.setAttribute("open", "") : this.removeAttribute("open");
    }
    get openerElement() {
      return (this._openerElement =
        this._openerElement ||
        (this.previousElementSibling &&
        this.previousElementSibling.getAttribute("is") === "u-toggle-megaroll"
          ? this.previousElementSibling
          : null));
    }
    get headerElement() {
      return (this._headerElement =
        this._headerElement || this.closest(".header"));
    }
    get headerMenuElement() {
      return (this._headerMenuElement =
        this._headerMenuElement ||
        this.closest(".header__menu") ||
        this.headerElement);
    }
    async getOpeningMode() {
      return (
        await window.customElements.whenDefined("u-toggle-megaroll"),
        this.openerElement && this.openerElement.openingMode
      );
    }
    async connectedCallback() {
      ((this.openingMode = await this.getOpeningMode()),
        this.open &&
          (this.openingMode === "hover" &&
            this.headerMenuElement.addEventListener(
              "mouseleave",
              this.closeHandlerListener,
            ),
          document.addEventListener("click", this.closeHandlerListener),
          document.addEventListener("keydown", this.closeHandlerListener),
          this.headerMenuElement.addEventListener(
            "focusout",
            this.closeHandlerListener,
          )));
    }
    disconnectedCallback() {
      (this.openingMode === "hover" &&
        this.headerMenuElement.removeEventListener(
          "mouseleave",
          this.closeHandlerListener,
        ),
        document.removeEventListener("click", this.closeHandlerListener),
        document.removeEventListener("keydown", this.closeHandlerListener),
        this.headerMenuElement.removeEventListener(
          "focusout",
          this.closeHandlerListener,
        ));
    }
    attributeChangedCallback(e, t, s) {
      switch (e) {
        case "open":
          (t === null && s === ""
            ? (document
                .querySelectorAll("".concat(this.localName, "[open]"))
                .forEach((i) => {
                  this !== i && (i.open = !1);
                }),
              this.headerElement.classList.add("is-megarolled", "is-filled"),
              this.openerElement.classList.add("is-hovered"),
              this.classList.add("is-visible"),
              this.openerElement.hasAttribute("aria-expanded") &&
                this.openerElement.setAttribute("aria-expanded", "true"),
              this.openByHandle || this.openerElement.dispatchMousedownEvent(),
              this.openingMode === "hover" &&
                this.headerMenuElement.addEventListener(
                  "mouseleave",
                  this.closeHandlerListener,
                ),
              document.addEventListener("click", this.closeHandlerListener),
              document.addEventListener("keydown", this.closeHandlerListener),
              this.headerMenuElement.addEventListener(
                "focusout",
                this.closeHandlerListener,
              ))
            : s === null &&
              (this.classList.remove("is-visible"),
              this.openerElement.classList.remove("is-hovered"),
              this.headerElement.classList.remove("is-megarolled"),
              this.headerElement.classList.contains("is-sticked") ||
                this.headerElement.classList.remove("is-filled"),
              this.openerElement.hasAttribute("aria-expanded") &&
                this.openerElement.setAttribute("aria-expanded", "false"),
              this.contains(document.activeElement) &&
                this.openerElement.focus({ preventScroll: !0 }),
              (this.openByHandle = null),
              this.openingMode === "hover" &&
                this.headerMenuElement.removeEventListener(
                  "mouseleave",
                  this.closeHandlerListener,
                ),
              document.removeEventListener("click", this.closeHandlerListener),
              document.removeEventListener(
                "keydown",
                this.closeHandlerListener,
              ),
              this.headerMenuElement.removeEventListener(
                "focusout",
                this.closeHandlerListener,
              )),
            ((t === null && s === "") || s === null) &&
              this.dispatchEvent(new CustomEvent("toggle", { bubbles: !0 })));
          break;
      }
    }
    closeHandler(e) {
      (e.type === "click" && e.target.closest(this.selector.close)) ||
      e.type === "mouseleave" ||
      (e.type === "keydown" && e.key === "Escape")
        ? (this.open = !1)
        : e.type === "focusout" &&
            e.relatedTarget &&
            e.relatedTarget !== this.openerElement &&
            !this.contains(e.relatedTarget)
          ? (this.open = !1)
          : e.type === "click" &&
            e.currentTarget === document &&
            !this.openerElement.contains(e.target) &&
            !this.contains(e.target) &&
            (this.open = !1);
    }
  },
  _e = class extends HTMLElement {
    constructor() {
      super();
    }
    get headerElement() {
      return document.querySelector("u-header");
    }
    async connectedCallback() {
      this.headerElement &&
        (await window.customElements.whenDefined("u-header"));
    }
    async disconnectedCallback() {
      this.headerElement &&
        (await window.customElements.whenDefined("u-header"));
    }
  },
  Be = class extends HTMLAnchorElement {
    constructor() {
      (super(),
        this.addEventListener("click", this.toggleHandler.bind(this)),
        this.addEventListener("keydown", this.toggleHandler.bind(this)));
    }
    get type() {
      return this.dataset.type;
    }
    get typeName() {
      return this.dataset.typeName;
    }
    get controlledElement() {
      return this.type && this.typeName
        ? document.querySelector(
            "".concat(this.type, '[data-name="').concat(this.typeName, '"]'),
          )
        : this.type
          ? document.querySelector(this.type)
          : null;
    }
    toggleHandler(e) {
      (e.type === "click" && e.preventDefault(),
        e.type === "keydown" &&
          e.code === "Space" &&
          (e.preventDefault(), this.click()),
        e.type === "click" &&
          this.controlledElement &&
          ((this.controlledElement.originOpener = this),
          (this.controlledElement.open = !this.controlledElement.open)));
    }
  },
  Fe = class extends HTMLButtonElement {
    constructor() {
      (super(), this.addEventListener("click", this.toggleHandler.bind(this)));
    }
    get type() {
      return this.dataset.type;
    }
    get typeName() {
      return this.dataset.typeName;
    }
    get controlledElement() {
      return this.type && this.typeName
        ? document.querySelector(
            "".concat(this.type, '[data-name="').concat(this.typeName, '"]'),
          )
        : this.type
          ? document.querySelector(this.type)
          : null;
    }
    toggleHandler(e) {
      (e.preventDefault(),
        this.controlledElement &&
          ((this.controlledElement.originOpener = this),
          (this.controlledElement.open = !this.controlledElement.open)));
    }
  },
  Ve = class extends HTMLButtonElement {
    constructor() {
      (super(),
        this.addEventListener("click", this.toggleHandler.bind(this)),
        (this.attributesProgressEventListener =
          this.attributesProgressEvent.bind(this)));
    }
    get targetedElement() {
      return (
        (this.dataset.target && document.querySelector(this.dataset.target)) ||
        null
      );
    }
    get gridValue() {
      return this.dataset.value;
    }
    connectedCallback() {
      document.addEventListener(
        "uniqart:attributes:update:grid-switcher:progress",
        this.attributesProgressEventListener,
      );
    }
    disconnectedCallback() {
      document.removeEventListener(
        "uniqart:attributes:update:grid-switcher:progress",
        this.attributesProgressEventListener,
      );
    }
    attributesProgressEvent() {
      this.classList.remove("is-active");
    }
    toggleHandler(e) {
      (e.preventDefault(),
        this.targetedElement &&
          !this.classList.contains("is-active") &&
          (this.targetedElement.setAttribute("data-grid", this.gridValue),
          b({
            attributes: { grid_mode: this.gridValue },
            subEvent: "grid-switcher",
          }),
          this.classList.add("is-active")));
    }
  },
  p = [],
  y = (e, t = !0) => {
    const s = e.id || e.localName;
    (t === !0 ? p.push(s) : p.indexOf(s) !== -1 && p.splice(p.indexOf(s), 1),
      document.body.classList.toggle("is-locked", p.length > 0));
  },
  Q = class extends g {
    constructor() {
      (super(),
        (this.selector = { close: ".u-drawer-close" }),
        this.addEventListener("click", this.closeHandler.bind(this)),
        this.addEventListener(
          "scroll",
          P(this.scrollHandler.bind(this), 50),
          !0,
        ));
    }
    attributeChangedCallback(e, t, s) {
      switch ((super.attributeChangedCallback(e, t, s), e)) {
        case "open":
          t === null && s === ""
            ? (this.classList.add("is-visible"), y(this, !0))
            : s === null && (this.classList.remove("is-visible"), y(this, !1));
          break;
      }
    }
    closeHandler(e) {
      e.target.closest(this.selector.close) &&
        (e.preventDefault(), (this.open = !1));
    }
    scrollHandler(e) {
      e.target === e.target.closest(".drawer__body") &&
        (e.target.scrollTop > 0
          ? this.classList.add("has-scrolled")
          : this.classList.remove("has-scrolled"));
    }
  },
  De = class extends Q {
    constructor() {
      (super(),
        (this.drawerForcedClose = null),
        this.addEventListener("mouseenter", this.clearForcedClose.bind(this)),
        this.addEventListener("mousemove", this.clearForcedClose.bind(this)),
        this.addEventListener("keydown", this.clearForcedClose.bind(this)),
        this.addEventListener("touchmove", this.clearForcedClose.bind(this), {
          passive: !0,
        }));
    }
    get shouldCloseOnOutsideClick() {
      return !0;
    }
    attributeChangedCallback(e, t, s) {
      switch ((super.attributeChangedCallback(e, t, s), e)) {
        case "open":
          t === null &&
            s === "" &&
            setTimeout(() => {
              this.open = !1;
            }, 1200);
          break;
      }
    }
    disconnectedCallback() {
      this.drawerForcedClose && clearTimeout(this.drawerForcedClose);
    }
    clearForcedClose() {
      clearTimeout(this.drawerForcedClose);
    }
  },
  Ne = class extends g {
    constructor() {
      (super(),
        (this.selector = { close: ".u-modal-close" }),
        this.addEventListener("click", this.closeHandler.bind(this)));
    }
    get removeOnClose() {
      return this.dataset.removeOnClose === "true";
    }
    attributeChangedCallback(e, t, s) {
      switch ((super.attributeChangedCallback(e, t, s), e)) {
        case "open":
          if (t === null && s === "") this.classList.add("is-visible");
          else if (
            s === null &&
            (this.classList.remove("is-visible"), this.removeOnClose === !0)
          ) {
            const i = getComputedStyle(this).transitionDuration || "0s",
              n = parseFloat(i) * (i.endsWith("ms") ? 1 : 1e3);
            setTimeout(() => {
              this.open || this.remove();
            }, n);
          }
          break;
      }
    }
    closeHandler(e) {
      e.target.closest(this.selector.close) &&
        (e.preventDefault(), (this.open = !1));
    }
  },
  Re = class extends g {
    constructor() {
      (super(),
        (this.selector = {
          close: ".u-offcanvas-close",
          openSubmenu: ".u-offcanvas-open-submenu",
        }),
        this.addEventListener("click", this.closeHandler.bind(this)),
        this.addEventListener("click", this.openSubmenu.bind(this)),
        this.addEventListener(
          "scroll",
          this.fixUnwantedScrollLeft.bind(this),
          !0,
        ),
        window.Shopify.designMode &&
          ((this.shopifySectionSelectListener = () => (this.open = !0)),
          (this.shopifySectionDeselectListener = () => (this.open = !1))));
    }
    connectedCallback() {
      window.Shopify.designMode &&
        (this.closest(".shopify-section").addEventListener(
          "shopify:section:select",
          this.shopifySectionSelectListener,
        ),
        this.closest(".shopify-section").addEventListener(
          "shopify:section:deselect",
          this.shopifySectionDeselectListener,
        ));
    }
    disconnectedCallback() {
      (super.disconnectedCallback(),
        window.Shopify.designMode &&
          (this.closest(".shopify-section").removeEventListener(
            "shopify:section:select",
            this.shopifySectionSelectListener,
          ),
          this.closest(".shopify-section").removeEventListener(
            "shopify:section:deselect",
            this.shopifySectionDeselectListener,
          )));
    }
    attributeChangedCallback(e, t, s) {
      switch ((super.attributeChangedCallback(e, t, s), e)) {
        case "open":
          t === null && s === ""
            ? ((this.querySelector(".offcanvas__body").scrollTop = 0),
              this.classList.add("is-visible"),
              y(this, !0))
            : s === null &&
              (this.querySelectorAll("u-offcanvas-submenu[open]").forEach(
                (i) => {
                  (i.focusTrap.pause(),
                    setTimeout(() => {
                      i.open = !1;
                    }, 200));
                },
              ),
              this.classList.remove("is-visible"),
              y(this, !1));
          break;
      }
    }
    openSubmenu(e) {
      if (e.target.closest(this.selector.openSubmenu)) {
        e.preventDefault();
        const t = e.target.closest(this.selector.openSubmenu),
          s = this.querySelector(
            'u-offcanvas-submenu[data-name="'.concat(t.dataset.name, '"]'),
          );
        s && ((s.originOpener = t), (s.open = !0));
      }
    }
    closeHandler(e) {
      e.target.closest(this.selector.close) &&
        (e.preventDefault(), (this.open = !1));
    }
    fixUnwantedScrollLeft(e) {
      getComputedStyle(e.target).overflowX === "hidden" &&
        e.target.scrollLeft > 0 &&
        (e.target.scrollLeft = 0);
    }
  },
  Ue = class extends g {
    constructor() {
      (super(),
        (this.selector = { close: ".u-offcanvas-submenu-close" }),
        this.addEventListener("click", this.closeHandler.bind(this)));
    }
    get deactivateFocusTrapOptions() {
      return this.offcanvasElement.open ? null : { returnFocus: !1 };
    }
    get offcanvasElement() {
      return (this._offcanvasElement =
        this._offcanvasElement || this.closest("u-offcanvas"));
    }
    attributeChangedCallback(e, t, s) {
      switch ((super.attributeChangedCallback(e, t, s), e)) {
        case "open":
          t === null && s === ""
            ? (this.offcanvasElement.classList.add("is-subexpanded"),
              this.classList.add("is-visible"))
            : s === null &&
              (this.offcanvasElement.classList.remove("is-subexpanded"),
              setTimeout(() => {
                this.open ||
                  ((this.scrollTop = 0),
                  this.classList.remove("is-visible"),
                  this.querySelectorAll("u-accordion[open]").forEach((i) => {
                    i.open = !1;
                  }));
              }, 300));
          break;
      }
    }
    closeHandler(e) {
      e.target.closest(this.selector.close) &&
        (e.preventDefault(), (this.open = !1));
    }
  },
  q = new Map();
async function h(e, t) {
  const s = e;
  if (q.has(s)) return Promise.resolve(new Response(new Blob([q.get(s)])));
  const i = await fetch(e, t);
  if (i.status === 200 && !window.Shopify.designMode) {
    const n = i.headers.get("Content-Type");
    n &&
      (n.match(/application\/json/i) || n.match(/text\//i)) &&
      i
        .clone()
        .text()
        .then((r) => {
          q.set(s, r);
        });
  }
  return i;
}
const $ = (e, t, s, i = !1, n = !1) => {
    if (e.querySelector(t))
      for (let r of t)
        e.querySelectorAll(r).forEach((a, o) => {
          const c = s.querySelectorAll(r)[o];
          i === !0
            ? c && a.insertAdjacentHTML("beforeend", c.innerHTML)
            : n === !0
              ? c && a.previousHTMLContent !== c.innerHTML
                ? ((a.previousHTMLContent = c.innerHTML),
                  (a.innerHTML = c.innerHTML))
                : c || (a.innerHTML = "")
              : (a.innerHTML = (c && c.innerHTML) || "");
        });
  },
  S = class extends HTMLElement {
    constructor() {
      (super(),
        (this.$swiper = this.classList.contains("swiper")
          ? this
          : this.querySelector(".swiper")),
        this.addEventListener(
          "keydown",
          this.toggleSwiperScrollOnFocus.bind(this),
        ),
        this.addEventListener(
          "keyup",
          this.toggleSwiperScrollOnFocus.bind(this),
        ));
    }
    get type() {
      return this.dataset.type;
    }
    get swiperOptions() {
      let e = {
        loop: !1,
        observer: !0,
        observeParents: !0,
        modules: [F, v, k],
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          bulletElement: "button",
          clickable: !0,
        },
      };
      return (
        this.type ||
          (e = Object.assign({}, e, {
            slidesPerView: 1.3,
            spaceBetween: 20,
            centerInsufficientSlides: !0,
            breakpoints: {
              768: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 24 },
              1024: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 24 },
            },
          })),
        this.type === "products" &&
          (e = Object.assign({}, e, {
            slidesPerView: 1.3,
            spaceBetween: 20,
            centerInsufficientSlides: !0,
            breakpoints: {
              768: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 24 },
              1024: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 24 },
            },
            pagination: {
              el: this.querySelector(".swiper-pagination--main"),
              bulletElement: "button",
              clickable: !0,
            },
            modules: [F, V, v, k],
          })),
        this.type === "gallery" &&
          (e = Object.assign({}, e, {
            slidesPerView: 1,
            spaceBetween: 20,
            a11y: { scrollOnFocus: "always" },
            navigation: !1,
            on: {
              slideChangeTransitionEnd: (t) => {
                t.el.querySelectorAll("video").forEach((s) => {
                  const isActive = s
                    .closest(".swiper-slide")
                    .classList.contains("swiper-slide-active");
                  if (isActive) {
                    s.play();
                  } else {
                    s.pause();
                  }
                });
              },
            },
          })),
        this.type === "teaser" &&
          (e = Object.assign({}, e, {
            effect: "fade",
            followFinger: !1,
            fadeEffect: { crossFade: !0 },
            modules: [v, V, ee],
            navigation: {
              nextEl: this.querySelector(".swiper-teaser-button-next"),
              prevEl: this.querySelector(".swiper-teaser-button-prev"),
            },
            pagination: {
              el: this.querySelector(".swiper-pagination"),
              clickable: !0,
            },
            slidesPerView: 1,
            spaceBetween: 1,
            cache: !1,
            nested: !0,
            on: {
              init: function () {
                (this.el.addEventListener("mouseenter", () => {
                  this.slideNext(500);
                }),
                  this.el.addEventListener("mouseleave", () => {
                    this.slideTo(0, 500);
                  }));
              },
            },
          })),
        (this.type === "upsell" || this.type === "cart-recenty-viewed") &&
          (e = Object.assign({}, e, {
            slidesPerView: 2,
            spaceBetween: 20,
            navigation: !1,
            on: {
              slideChangeTransitionEnd: (t) => {
                t.el.querySelector("video") &&
                  t.el.querySelectorAll("video").forEach((s) => {
                    ((s.currentTime = 0), s.pause());
                  });
              },
            },
          })),
        this.type == "panels" &&
          (e = Object.assign({}, e, {
            slidesPerView: 1.21,
            spaceBetween: 20,
            centerInsufficientSlides: !0,
            breakpoints: {
              768: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 },
              1024: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 46 },
              1280: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 72 },
            },
          })),
        this.type == "panels-auto" &&
          (e = Object.assign({}, e, {
            slidesPerView: 1,
            spaceBetween: 20,
            centerInsufficientSlides: !0,
            loop: !0,
            modules: [v, k, te],
            pagination: {
              el: this.querySelector(".swiper-pagination"),
              renderBullet: function (t, s) {
                return '\n              <button class="'.concat(
                  s,
                  '">\n                <svg class="swiper-pagination-circular-progress" width="100" height="100" viewBox="0 0 100 100">\n                  <circle class="swiper-pagination-circular-progress__circle" cx="50" cy="50" r="45" stroke-width="10"></circle>\n                </svg>\n              </button>\n              ',
                );
              },
            },
            autoplay: {
              delay: 5e3,
              disableOnInteraction: !1,
              pauseOnMouseEnter: !0,
            },
            on: {
              autoplayTimeLeft: (t, s, i) => {
                t.pagination.el &&
                  t.pagination.el.style.setProperty("--progress", 1 - i);
              },
              autoplayStop: (t) => {
                t.pagination.el &&
                  t.pagination.el.style.removeProperty("--progress");
              },
            },
            breakpoints: {
              768: { slidesPerView: 3, spaceBetween: 20 },
              1024: { slidesPerView: 3, spaceBetween: 46 },
              1280: { slidesPerView: 3, spaceBetween: 72 },
            },
          })),
        this.type == "recently-viewed" &&
          (e = Object.assign({}, e, {
            slidesPerView: 2.5,
            spaceBetween: 20,
            breakpoints: { 768: { slidesPerView: 4, slidesPerGroup: 2 } },
          })),
        e
      );
    }
    set swiperCustomOptions(e) {
      this._swiperCustomOptions =
        typeof e == "object" ? Object.assign({}, this.swiperOptions, e) : null;
    }
    get options() {
      return this._swiperCustomOptions || this.swiperOptions;
    }
    getClosestSliderFromElement(e) {
      return (
        Array.from(this.querySelectorAll(e)).find(
          (t) => t.closest(this.localName) === this,
        ) || null
      );
    }
    initSwiper() {
      ((!this.swiper || (this.swiper && this.swiper.destroyed)) &&
        (this.swiper = new se(this.$swiper, this.options)),
        this.swiper &&
          this.swiper.params.a11y &&
          this.swiper.params.a11y.enabled &&
          this.swiper.params.a11y.scrollOnFocus !== "always" &&
          (this.swiper.params.a11y.scrollOnFocus = !1));
    }
    connectedCallback() {
      this.initSwiper();
    }
    disconnectedCallback() {
      this.swiper && this.swiper.initialized && this.swiper.destroy();
    }
    toggleSwiperScrollOnFocus(e) {
      !this.swiper ||
        !this.swiper.params.a11y ||
        !this.swiper.params.a11y.enabled ||
        this.swiper.params.a11y.scrollOnFocus === "always" ||
        (this.options.a11y && this.options.a11y.scrollOnFocus === !1) ||
        (this.swiper.params.a11y.scrollOnFocus =
          e.type === "keydown" && e.key === "Tab");
    }
  },
  C = class extends HTMLElement {
    constructor() {
      (super(),
        (this.selector = { json: ".u-product-json" }),
        (this.variantChangeEventListener = this.variantChangeEvent.bind(this)),
        (this.quantityChangeEventListener =
          this.quantityChangeEvent.bind(this)));
    }
    get productElement() {
      return (this._productElement =
        this._productElement || this.closest("u-product"));
    }
    get productJsonElement() {
      return this.productElement.querySelector(
        this.productElement.selector.json,
      );
    }
    get productJsonParser() {
      return (
        this.productJsonElement &&
        JSON.parse(this.productJsonElement.textContent)
      );
    }
    get updateUrl() {
      return this.productElement.dataset.updateUrl === "true";
    }
    get emailAlertRedirect() {
      return this.productElement.dataset.emailAlertRedirect === "true";
    }
    get currentProduct() {
      return (this.productElement._currentProduct =
        this.productElement._currentProduct || this.productJsonParser || null);
    }
    set currentProduct(e) {
      this.productElement._currentProduct = e;
    }
    get currentVariant() {
      return (this.currentProduct && this.currentProduct.current_variant) || !1;
    }
    connectedCallback() {
      this.productElement &&
        (this.productElement.addEventListener(
          "product:variant:change",
          this.variantChangeEventListener,
        ),
        this.productElement.addEventListener(
          "product:quantity:change",
          this.quantityChangeEventListener,
        ));
    }
    disconnectedCallback() {
      this.productElement &&
        (this.productElement.removeEventListener(
          "product:variant:change",
          this.variantChangeEventListener,
        ),
        this.productElement.removeEventListener(
          "product:quantity:change",
          this.quantityChangeEventListener,
        ));
    }
    variantChangeEvent(e) {}
    quantityChangeEvent(e) {}
  },
  G = class extends C {
    constructor() {
      (super(),
        (this.selector = {
          idInput: '[name="id"]',
          optionInput: '[name^="options"]',
          quantityInput: '[name="quantity"]',
          propertyInput: '[name^="properties"]',
          submitButton: 'button[type="submit"]',
        }),
        (this.$form = this.querySelector("form")),
        (this.$idInput = this.querySelector(this.selector.idInput)),
        (this.$submitButton = this.querySelector(this.selector.submitButton)),
        (this.renderContentStartedEventListener =
          this.renderContentStartedEvent.bind(this)),
        this.productElement &&
          this.$form &&
          this.$idInput &&
          ((this.$idInput.disabled = !1),
          this.addEventListener("change", this.changeQuantity.bind(this)),
          this.$form.addEventListener("submit", this.submitForm.bind(this)),
          this.classList.remove("is-pending")));
    }
    get selectedQuantity() {
      return (
        (this.querySelector(this.selector.quantityInput) &&
          parseInt(this.querySelector(this.selector.quantityInput).value)) ||
        1
      );
    }
    get customEventDetail() {
      return {
        product: this.currentProduct,
        variant: this.currentVariant,
        quantity: this.selectedQuantity,
      };
    }
    get modalEmailAlertElement() {
      return this.productElement.querySelector(
        'u-modal[data-name="product-email-alert"]',
      );
    }
    connectedCallback() {
      (super.connectedCallback(),
        this.productElement &&
          this.productElement.addEventListener(
            "product:render-content:started",
            this.renderContentStartedEventListener,
          ));
    }
    disconnectedCallback() {
      (super.disconnectedCallback(),
        this.productElement &&
          this.productElement.removeEventListener(
            "product:render-content:started",
            this.renderContentStartedEventListener,
          ));
    }
    variantChangeEvent(e) {
      const t = e.detail.variant,
        s = e.detail.quantity;
      (this.updateInputId(t),
        this.updateSubmitButton(t, s),
        this.updateUrl && this.updateHistoryUrl(t));
    }
    renderContentStartedEvent(e) {
      (this.$submitButton &&
        this.$submitButton.setAttribute("disabled", "disabled"),
        this.$form &&
          this.$form.getAttribute("id") &&
          this.productElement
            .querySelectorAll(
              ""
                .concat(this.selector.submitButton, '[form="')
                .concat(this.$form.getAttribute("id"), '"]'),
            )
            .forEach((t) => {
              t.setAttribute("disabled", "disabled");
            }));
    }
    quantityChangeEvent(e) {
      const t = e.detail.variant,
        s = e.detail.quantity;
      (this.updateInputQuantity(s), this.updateSubmitButton(t, s));
    }
    changeQuantity(e) {
      e.target.closest(this.selector.quantityInput) &&
        this.dispatchCustomEvent("product:quantity:change");
    }
    dispatchCustomEvent(e, t = !0) {
      this.productElement.dispatchEvent(
        new CustomEvent(e, {
          bubbles: !0,
          detail: (t && this.customEventDetail) || null,
        }),
      );
    }
    submitForm(e) {
      if (
        (e.preventDefault(),
        this.currentVariant && this.currentVariant.available === !1)
      ) {
        (this.emailAlertRedirect &&
          window.location.assign(
            ""
              .concat(
                this.currentProduct.url +
                  (this.currentProduct.url.indexOf("?") !== -1 ? "&" : "?"),
                "variant=",
              )
              .concat(this.currentVariant.id, "#email-alert"),
          ),
          this.modalEmailAlertElement &&
            (this.modalEmailAlertElement.open = !0));
        return;
      }
      !this.currentVariant ||
        !this.$submitButton ||
        this.$submitButton.hasAttribute("disabled") ||
        this.$submitButton.classList.contains("is-progress") ||
        this.$submitButton.classList.contains("is-success") ||
        (this.$submitButton.classList.add("is-progress"),
        ie({
          form: e.target,
          sections_url: ""
            .concat(theme.routes.rootPath, "variants/")
            .concat(this.currentVariant.id),
        }));
    }
    updateInputId(e) {
      this.$idInput.value = e ? e.id : null;
    }
    updateInputQuantity(e) {
      ((this.querySelector(this.selector.quantityInput).value = e),
        this.querySelector(this.selector.quantityInput).dispatchEvent(
          new Event("input", { bubbles: !0 }),
        ));
    }
    updateSubmitButton(e, t) {
      if (this.$submitButton) {
        if (!e || !t || t === 0) {
          (this.$submitButton.setAttribute("disabled", "disabled"),
            this.$submitButton.classList.add("is-disabled"),
            (this.$submitButton.querySelector(".btn__label").innerHTML =
              theme.strings.product.unavailable));
          return;
        } else
          (this.$submitButton.removeAttribute("disabled"),
            this.$submitButton.classList.remove("is-disabled"));
        e.available
          ? ((this.$submitButton.querySelector(".btn__label").innerHTML =
              theme.strings.product.addToCart),
            this.$submitButton
              .querySelector(".product__price")
              .classList.remove("is-hidden"))
          : ((this.$submitButton.querySelector(".btn__label").innerHTML =
              theme.strings.product.emailAlert),
            this.$submitButton
              .querySelector(".product__price")
              .classList.add("is-hidden"));
      }
    }
    updateHistoryUrl(e) {
      const t = new URL(this.currentProduct.url, window.location.href);
      (e && t.searchParams.set("variant", e.id),
        history.replaceState({ path: t.toString() }, null, t.toString()));
    }
  },
  ze = class extends G {
    constructor() {
      (super(),
        (this.selector = Object.assign({}, this.selector, {
          boxProductsContainer: ".u-box-products",
          boxProducts: ".box__choices-product",
          json: ".u-box-product-json",
          boxSectionId: "box-products",
          input: ".u-quantity-switcher-input",
          plus: ".u-quantity-switcher-plus",
          minus: ".u-quantity-switcher-minus",
          submitButton: 'button[name="add"]',
        })),
        (this._addedProducts = []),
        (this.$boxProductsContainer =
          this.querySelector(this.selector.boxProductsContainer) || null),
        (this.removeProductEventListener = this.removeProductEvent.bind(this)));
    }
    get maxNumberOfProducts() {
      return this.currentProduct.bundle_max_products;
    }
    get quantityInputs() {
      return this.querySelectorAll(this.selector.input) || [];
    }
    get numberOfProducts() {
      return this._addedProducts.length || 0;
    }
    get plusButtons() {
      return this.querySelectorAll(this.selector.plus) || [];
    }
    get itemsToAdd() {
      const firstKey = "Item 1"
      const secondKey = "Item 2"
      const thirdKey = "Item 3"
      const isBoxKey = "_box_item"

      const t = this._addedProducts.map((i) => i.productHandle).join("-"),
        s = Date.now();

      let e = [];
      // let e = [{
      //   id: 50778686456150,
      //   quantity: 1,
      //   parent_id: this.currentVariant.id,
      //   properties: { [isBoxKey]: !0, _uniqueId: s },
      // }];

      return (
        this._addedProducts.forEach((i) => {
          e.push({
            id: parseInt(i.variantId),
            quantity: 1,
            properties: { [isBoxKey]: !0, _uniqueId: s },
          });
        }),
        e.push({
          id: this.currentVariant.id,
          quantity: 1,
          properties: {
            [firstKey]: this._addedProducts[0].productTitle,
            [secondKey]: this._addedProducts[1].productTitle,
            [thirdKey]: this._addedProducts[2].productTitle,
            _uniqueId: s,
          },
        }),
        e
      );
    }
    get targetProduct() {
      return this._targetProduct;
    }
    set targetProduct(e) {
      if (!e) return;
      const t = e.id,
        s = e.title,
        i = e.handle,
        n = e.featured_image_html,
        r = e.variant,
        a = e.delete_button;
      this._targetProduct = {
        productId: t,
        productTitle: s,
        productHandle: i,
        productImage: n,
        variantId: r,
        deleteButton: a,
      };
    }
    connectedCallback() {
      (super.connectedCallback(),
        this.$boxProductsContainer &&
          this.$boxProductsContainer.addEventListener(
            "click",
            this.removeProductEventListener,
          ));
    }
    disconnectedCallback() {
      (super.disconnectedCallback(),
        this.$boxProductsContainer &&
          this.$boxProductsContainer.removeEventListener(
            "click",
            this.removeProductEventListener,
          ));
    }
    async submitForm(e) {
      const t = this.currentVariant;
      if (
        ((this.$form.resetPristine = "reinit"),
        e.preventDefault(),
        t && t.available === !1)
      ) {
        super.submitForm(e);
        return;
      }
      !t ||
        !this.$submitButton ||
        this.$submitButton.hasAttribute("disabled") ||
        this.$submitButton.classList.contains("is-progress") ||
        this.$submitButton.classList.contains("is-success") ||
        (this.$submitButton.classList.add("is-progress"),
        ne({ items: this.itemsToAdd }));
    }
    changeQuantity(e) {
      const t = e.target,
        s = t.closest(".product");
      this.targetProduct = JSON.parse(
        s.querySelector(this.selector.json).textContent,
      );
      const i = parseInt(t.dataset.prevValue || 0),
        n = parseInt(t.value);
      if (((t.dataset.prevValue = n), n > i))
        this._addedProducts.push(this.targetProduct);
      else {
        const r = this._addedProducts.findIndex(
          (a) => a.variantId === this.targetProduct.variantId,
        );
        this._addedProducts.splice(r, 1);
      }
      (this.renderContent(),
        this.buttonToggle(this.numberOfProducts >= this.maxNumberOfProducts));
    }
    buttonToggle(e) {
      const t = this.$submitButton.querySelector(".btn__label"),
        s = this.$submitButton.querySelector(".product__price"),
        i = this.numberOfProducts === 0,
        n = this.numberOfProducts > 0 && !e;
      (this.$submitButton.toggleAttribute("disabled", !e),
        this.$submitButton.classList.toggle("is-disabled", !e),
        e
          ? ((t.textContent = theme.strings.product.addToCart),
            s.classList.remove("is-hidden"))
          : i
            ? ((t.textContent =
                theme.strings.product.bundle.empty_submit.replace(
                  "{{ max_products }}",
                  this.maxNumberOfProducts,
                )),
              s.classList.remove("is-hidden"))
            : n &&
              ((t.textContent = ""
                .concat(theme.strings.product.bundle.partial_submit, " ")
                .concat(this.numberOfProducts, "/")
                .concat(this.maxNumberOfProducts)),
              s.classList.add("is-hidden")),
        this.plusButtons.forEach((r) => {
          const a = r.previousElementSibling,
            o = parseInt(a.value) >= parseInt(a.max) || e;
          (r.toggleAttribute("disabled", o),
            r.classList.toggle("is-disabled", o));
        }));
    }
    renderContent() {
      this.$boxProductsContainer &&
        ((this.$boxProductsContainer.innerHTML = ""),
        this._addedProducts.forEach((e) => {
          this.$boxProductsContainer.insertAdjacentHTML(
            "beforeend",
            '\n        <li class="box__choices-product" data-product-id="'
              .concat(e.productId, '">\n          ')
              .concat(e.deleteButton, "\n          ")
              .concat(e.productImage, "\n        </li>  \n      "),
          );
        }));
    }
    removeProductEvent(e) {
      const t = e.target.closest("button");
      if (!t) return;
      const s = t.closest(this.selector.boxProducts);
      if (!s) return;
      const i = s.dataset.productId,
        n = Array.from(this.quantityInputs).find(
          (r) => r.closest(".product").dataset.productId === i.toString(),
        );
      n &&
        parseInt(n.value) > 0 &&
        ((n.value = parseInt(n.value) - 1),
        n.dispatchEvent(new Event("change", { bubbles: !0 })));
    }
  },
  je = class extends C {
    constructor() {
      (super(),
        this.formElement &&
          this.currentProduct &&
          this.addEventListener("change", this.changeOption.bind(this)));
    }
    get formElement() {
      return this.closest(this.dataset.form) || null;
    }
    get sectionId() {
      return this.dataset.sectionId;
    }
    get sectionElement() {
      return (
        (this.sectionId &&
          document.getElementById("shopify-section-".concat(this.sectionId))) ||
        null
      );
    }
    get containerElement() {
      return this.sectionElement || this.productElement;
    }
    get targets() {
      const e = [];
      if (this.dataset.targets)
        for (let t of this.dataset.targets.split(","))
          ((t = t.trim()), t && e.push(t));
      return e.length > 0 ? e : null;
    }
    get prerenderOptions() {
      return this.dataset.prerenderOptions === "false"
        ? !1
        : this.dataset.prerenderOptions === "true"
          ? !0
          : "intersection";
    }
    get selectedOptionsValues() {
      return Array.from(
        this.querySelectorAll(this.formElement.selector.optionInput),
      )
        .filter(
          (e) =>
            e.checked === !0 || e.checked === void 0 || e.type === "hidden",
        )
        .map(
          (e) => e.value || (e.selectedOptions && e.selectedOptions[0].value),
        );
    }
    get intersectionObserver() {
      return (this._intersectionObserver =
        this._intersectionObserver ||
        (window.IntersectionObserver
          ? new IntersectionObserver((e) => {
              e.forEach((t) => {
                t.isIntersecting &&
                  (this.optionsPrerendering(),
                  this.intersectionObserver.unobserve(this));
              });
            })
          : null));
    }
    getOptionValuesByOption(e) {
      const t = e.localName === "option" ? e.parentNode.name : e.name;
      return [
        e,
        ...Array.from(
          this.querySelectorAll(
            ""
              .concat(this.formElement.selector.optionInput, ':not([name="')
              .concat(t, '"]), ')
              .concat(this.formElement.selector.optionInput, ':not([name="')
              .concat(t, '"]) option'),
          ),
        ).filter(
          (s) => s.checked === !0 || s.type === "hidden" || s.selected === !0,
        ),
      ]
        .sort(
          (s, i) =>
            parseInt(s.dataset.optionPosition) -
            parseInt(i.dataset.optionPosition),
        )
        .map((s) => s.value);
    }
    getOptionElementByOptionValueId(e) {
      const t = this.querySelector('[value="'.concat(e, '"]'));
      return (t && t.closest("select")) || t;
    }
    connectedCallback() {
      (super.connectedCallback(),
        this.prerenderOptions === "intersection" && this.intersectionObserver
          ? this.intersectionObserver.observe(this)
          : this.prerenderOptions === !0 && this.optionsPrerendering());
    }
    disconnectedCallback() {
      (super.disconnectedCallback(),
        this.intersectionObserver &&
          (this.intersectionObserver.unobserve(this),
          this.intersectionObserver.disconnect()));
    }
    optionsPrerendering() {
      Array.from(
        this.querySelectorAll(
          ""
            .concat(this.formElement.selector.optionInput, ", ")
            .concat(this.formElement.selector.optionInput, " option"),
        ),
      )
        .filter(
          (e) => (e.checked === !1 && e.type !== "hidden") || e.selected === !1,
        )
        .forEach((e) => {
          const t = this.getOptionValuesByOption(e);
          let s = this.currentProduct.url;
          for (let r of t) {
            const a = Array.from(
              this.querySelectorAll(this.formElement.selector.optionInput),
            ).find((o) => o.value === r);
            if (a && a.dataset.productUrl) {
              s = a.dataset.productUrl;
              break;
            }
          }
          const i = new URL(s, window.location.href);
          (i.searchParams.set("option_values", t.join(",")),
            i.searchParams.set("section_id", this.sectionId));
          const n = i.toString();
          (Array.isArray(this.productElement.optionsPrerenderingUrls) ||
            (this.productElement.optionsPrerenderingUrls = []),
            this.productElement.optionsPrerenderingUrls.indexOf(n) === -1 &&
              (this.productElement.optionsPrerenderingUrls.push(n),
              window.requestIdleCallback
                ? window.requestIdleCallback(() => h(n))
                : h(n)));
        });
    }
    async changeOption(e) {
      if (e.target.closest(this.formElement.selector.optionInput)) {
        const t =
            (e.target.selectedOptions && e.target.selectedOptions[0]) ||
            e.target,
          s = t.dataset.productUrl || this.currentProduct.url,
          i = new URL(s, window.location.href);
        (i.searchParams.set(
          "option_values",
          this.selectedOptionsValues.join(","),
        ),
          i.searchParams.set("section_id", this.sectionId),
          await this.renderContent(i, t.value),
          (this.currentProduct = this.productJsonParser),
          this.prerenderOptions === "intersection" && this.intersectionObserver
            ? this.intersectionObserver.observe(this)
            : this.prerenderOptions === !0 && this.optionsPrerendering(),
          this.formElement.dispatchCustomEvent("product:variant:change"));
      }
    }
    async renderContent(e, t) {
      var r;
      if (!this.containerElement)
        throw new Error("this.containerElement was not found");
      (this.formElement.dispatchCustomEvent(
        "product:render-content:started",
        !1,
      ),
        this.containerElement.classList.add("is-pending"),
        (r = this.containerElement.abortController) == null || r.abort(),
        (this.containerElement.abortController = new AbortController()));
      const s = await h(e.toString(), {
          signal: this.containerElement.abortController.signal,
        }),
        i = await s.text(),
        n = new DOMParser().parseFromString(i, "text/html").body;
      if (s.ok === !1)
        throw new Error(
          "Something went wrong in ProductVariantSelector.renderContent()",
        );
      (n.querySelector(this.productElement.selector.json) &&
        (this.productJsonElement.textContent = n.querySelector(
          this.productElement.selector.json,
        ).textContent),
        n.querySelector(this.localName) &&
          (this.innerHTML = n.querySelector(this.localName).innerHTML),
        $(this.containerElement, this.targets, n, !1, !0),
        this.updateElementAttributes(
          'u-modal[data-name^="product-view-"]',
          ["id", "data-name", "aria-label"],
          n,
        ),
        this.containerElement.classList.remove("is-pending"),
        this.tryFocus(t),
        this.formElement.dispatchCustomEvent(
          "product:render-content:complete",
          !1,
        ));
    }
    updateElementAttributes(e, t, s) {
      if (this.containerElement.closest(e) && s.querySelector(e)) {
        const i = this.containerElement.closest(e),
          n = s.querySelector(e);
        for (let r of t)
          i.hasAttribute(r) &&
            n.hasAttribute(r) &&
            i.setAttribute(r, n.getAttribute(r));
      }
    }
    tryFocus(e) {
      const t = this.getOptionElementByOptionValueId(e);
      t.localName === "select"
        ? setTimeout(() => {
            t.focus({ preventScroll: !0 });
          }, 0)
        : t && t.focus({ preventScroll: !0 });
    }
  },
  Ye = class extends HTMLInputElement {
    constructor() {
      (super(), this.addEventListener("change", this.changeOption.bind(this)));
    }
    get productElement() {
      return (this._productElement =
        this._productElement || this.closest("u-product"));
    }
    get targetOption() {
      return this.dataset.optionTarget;
    }
    get targetedElement() {
      return this.productElement.querySelector(
        '[name="'.concat(this.targetOption, '"]'),
      );
    }
    changeOption(e) {
      ((this.targetedElement.value = e.target.value),
        this.targetedElement.dispatchEvent(
          new Event("change", { bubbles: !0 }),
        ));
    }
  },
  A = class extends C {
    constructor() {
      super();
    }
    variantChangeEvent(e) {
      const t = e.detail.variant,
        s = e.detail.quantity;
      this.renderContent(t, s);
    }
    quantityChangeEvent(e) {
      const t = e.detail.variant,
        s = e.detail.quantity;
      this.renderContent(t, s);
    }
    renderContent(e, t) {
      e
        ? (this.classList.remove("is-hidden"),
          (this.innerHTML = f(e.price * t)))
        : this.classList.add("is-hidden");
    }
  },
  Qe = class extends A {
    constructor() {
      super();
    }
    renderContent(e, t) {
      (this.classList.remove("is-visible"),
        (this.innerHTML = ""),
        e.compare_at_price > e.price &&
          ((this.innerHTML = f(e.compare_at_price * t)),
          this.classList.add("is-visible")));
    }
  },
  Ge = class extends A {
    constructor() {
      super();
    }
    renderContent(e) {
      (this.classList.remove("is-visible"),
        (this.innerHTML = ""),
        e.compare_at_price > e.price &&
          ((this.innerHTML = "".concat(
            -Math.round(
              (e.compare_at_price - e.price) * (100 / e.compare_at_price),
            ),
            "%",
          )),
          this.classList.add("is-visible")));
    }
  },
  Je = class extends HTMLAnchorElement {
    constructor() {
      (super(),
        (this.variantChangeEventListener = this.variantChangeEvent.bind(this)));
    }
    get productElement() {
      return (this._productElement =
        this._productElement || this.closest("u-product"));
    }
    connectedCallback() {
      this.productElement &&
        this.href &&
        this.productElement.addEventListener(
          "product:variant:change",
          this.variantChangeEventListener,
        );
    }
    disconnectedCallback() {
      this.productElement &&
        this.productElement.removeEventListener(
          "product:variant:change",
          this.variantChangeEventListener,
        );
    }
    variantChangeEvent(e) {
      const t = e.detail.variant;
      this.updateLink(t);
    }
    updateLink(e) {
      const t = new URL(this.productElement.currentProduct.url, this.href);
      (t.searchParams.delete("variant"),
        e && t.searchParams.set("variant", e.id),
        this.setAttribute("href", t.toString()));
    }
  },
  We = class extends S {
    constructor() {
      (super(),
        (this.variantChangeEventListener = this.variantChangeEvent.bind(this)),
        (this.toggleSwiperListener = this.toggleSwiper.bind(this)));
    }
    get productElement() {
      return (this._productElement =
        this._productElement || this.closest("u-product"));
    }
    get initialSlideToVariantMedia() {
      return this.dataset.initialSlideToVariantMedia === "true";
    }
    async connectedCallback() {
      (this.toggleSwiper(),
        this.productElement &&
          this.productElement.addEventListener(
            "product:variant:change",
            this.variantChangeEventListener,
          ),
        window.addEventListener("resize", this.toggleSwiperListener));
    }
    disconnectedCallback() {
      (super.disconnectedCallback(),
        this.productElement &&
          this.productElement.removeEventListener(
            "product:variant:change",
            this.variantChangeEventListener,
          ),
        window.removeEventListener("resize", this.toggleSwiperListener));
    }
    variantChangeEvent(e) {
      const t = e.detail.variant;
      t && t.featured_media && t.featured_media && this.slideToVariantMedia(t);
    }
    slideToVariantMedia(e, t = 300) {
      const s =
        this.swiper &&
        this.swiper.slides.findIndex(
          (i) => parseInt(i.dataset.mediaId) === e.featured_media.id,
        );
      this.swiper && s !== -1 && this.swiper.slideTo(s, t);
    }
    toggleSwiper() {
      window.matchMedia("(max-width: 767px)").matches
        ? (this.initSwiper(),
          this.initialSlideToVariantMedia &&
            this.productElement &&
            this.productElement.currentVariant &&
            this.productElement.currentVariant.featured_media &&
            this.slideToVariantMedia(this.productElement.currentVariant, 0))
        : this.swiper && this.swiper.initialized && this.swiper.destroy();
    }
  },
  Ke = class extends HTMLElement {
    constructor() {
      super();
    }
    get currentProduct() {
      return this.dataset.product;
    }
    get sectionId() {
      return this.dataset.sectionId;
    }
    get limit() {
      return parseInt(this.dataset.limit) || 6;
    }
    get intent() {
      return this.dataset.intent;
    }
    connectedCallback() {
      this.currentProduct &&
        this.sectionId &&
        this.classList.contains("is-hidden") &&
        this.renderContent();
    }
    async renderContent() {
      const e = await fetch(
          ""
            .concat(theme.routes.productRecommendationsUrl, "?product_id=")
            .concat(this.currentProduct, "&limit=")
            .concat(this.limit, "&section_id=")
            .concat(
              this.sectionId + (this.intent ? "&intent=" + this.intent : ""),
            ),
        ),
        t = await e.text(),
        s = new DOMParser().parseFromString(t, "text/html").body;
      if (
        e.ok === !1 &&
        window.Shopify.designMode &&
        !window.Shopify.visualPreviewMode
      )
        return this.renderContent();
      if (e.ok === !1)
        throw new Error(
          "Something went wrong in ProductsRecommendations.renderContent()",
        );
      ((this.innerHTML = s.querySelector(this.localName)
        ? s.querySelector(this.localName).innerHTML
        : ""),
        this.querySelector(".product--teaser") &&
          this.classList.remove("is-hidden"),
        this.dispatchEvent(
          new CustomEvent("recommendations:render-content:complete", {
            bubbles: !0,
          }),
        ));
    }
  };
function T(e, t) {
  let s = null;
  return (...i) => {
    (clearTimeout(s),
      (s = setTimeout(() => {
        e.apply(this, i);
      }, t)));
  };
}
const Xe = class extends HTMLElement {
    constructor() {
      (super(),
        (this.selector = {
          input: ".u-predictive-search-input",
          results: ".u-predictive-search-results",
          empty: ".u-predictive-search-empty",
        }),
        (this.$input = this.querySelector(this.selector.input)),
        (this.$results = this.querySelector(this.selector.results)),
        (this.autoFocusOnOpenListener = this.autoFocusOnOpen.bind(this)),
        this.supportPredictiveSearchApi &&
          this.$input &&
          this.$results &&
          ((this.initialContent = this.$results.innerHTML),
          (this.inputValue = null),
          this.$input.addEventListener(
            "input",
            T(this.searchInput.bind(this), 300),
          )));
    }
    get parentDrawerElement() {
      return (this._parentDrawerElement =
        this._parentDrawerElement || this.closest("u-drawer"));
    }
    get supportPredictiveSearchApi() {
      const e =
        (document.querySelector("#shopify-features") &&
          JSON.parse(
            document.querySelector("#shopify-features").textContent,
          )) ||
        null;
      return (e && e.predictiveSearch) || !1;
    }
    connectedCallback() {
      this.parentDrawerElement &&
        this.parentDrawerElement.addEventListener(
          "toggle",
          this.autoFocusOnOpenListener,
        );
    }
    disconnectedCallback() {
      this.parentDrawerElement &&
        this.parentDrawerElement.removeEventListener(
          "toggle",
          this.autoFocusOnOpenListener,
        );
    }
    searchInput(e) {
      var t;
      ((this.inputValue = e.target.value.trim() || null),
        (t = this.abortController) == null || t.abort(),
        (this.abortController = new AbortController()),
        this.classList.remove("has-results", "has-no-result"),
        this.inputValue
          ? (this.classList.add("is-pending"),
            (this.$results.innerHTML = ""),
            this.renderContent(this.inputValue))
          : ((this.$results.innerHTML = this.initialContent),
            this.classList.remove("is-pending")));
    }
    async renderContent(e) {
      const t = await h(
          ""
            .concat(theme.routes.predictiveSearchUrl, "?q=")
            .concat(
              encodeURIComponent(e),
              "&resources[limit_scope]=each&resources[options[fields]]=title,body,product_type,variants.title,variants.sku&section_id=predictive-search-results",
            ),
          { signal: this.abortController.signal },
        ),
        s = await t.text(),
        i = new DOMParser().parseFromString(s, "text/html").body;
      if (t.ok === !1)
        throw new Error(
          "Something went wrong in PredictiveSearch.renderContent()",
        );
      this.inputValue &&
        ((this.$results.innerHTML = i.firstElementChild.innerHTML),
        this.classList.remove("is-pending"),
        i.querySelector(this.selector.empty)
          ? this.classList.add("has-no-result")
          : this.classList.add("has-results"),
        this.dispatchEvent(
          new CustomEvent("predictive-search:render-content:complete", {
            bubbles: !0,
          }),
        ));
    }
    autoFocus() {
      const e = document.createElement("input");
      ((e.style.position = "absolute"),
        (e.style.top = "".concat(
          this.$input.getBoundingClientRect().top + window.scrollY,
          "px",
        )),
        (e.style.left = "".concat(
          this.$input.getBoundingClientRect().left + window.scrollX,
          "px",
        )),
        (e.style.margin = 0),
        (e.style.border = 0),
        (e.style.padding = 0),
        (e.style.width = 0),
        (e.style.height = 0),
        (e.style.opacity = 0),
        document.body.appendChild(e),
        e.focus({ preventScroll: !0 }),
        setTimeout(() => {
          (this.$input.focus({ preventScroll: !0 }),
            document.body.removeChild(e));
        }, 200));
    }
    autoFocusOnOpen(e) {
      e.target.open && this.autoFocus();
    }
  },
  Ze = class extends S {
    constructor() {
      (super(), (this.toggleSwiperListener = this.toggleSwiper.bind(this)));
    }
    connectedCallback() {
      (this.toggleSwiper(),
        window.addEventListener("resize", this.toggleSwiperListener));
    }
    disconnectedCallback() {
      (super.disconnectedCallback(),
        window.removeEventListener("resize", this.toggleSwiperListener));
    }
    toggleSwiper() {
      window.matchMedia("(min-width: 768px)").matches
        ? this.initSwiper()
        : this.swiper && this.swiper.initialized && this.swiper.destroy();
    }
  },
  et = class extends S {
    constructor() {
      (super(), (this.toggleSwiperListener = this.toggleSwiper.bind(this)));
    }
    connectedCallback() {
      (this.toggleSwiper(),
        window.addEventListener("resize", this.toggleSwiperListener));
    }
    disconnectedCallback() {
      (super.disconnectedCallback(),
        window.removeEventListener("resize", this.toggleSwiperListener));
    }
    toggleSwiper() {
      window.matchMedia("(max-width: 1023px)").matches
        ? this.initSwiper()
        : this.swiper && this.swiper.initialized && this.swiper.destroy();
    }
  },
  tt = new Set(),
  H = class extends HTMLElement {
    constructor() {
      (super(),
        (this.selector = {
          form: ".u-filters-form",
          toggle: ".u-filters-toggle",
          clear: ".u-filters-clear",
          range: ".u-filters-range",
          rangeSliderMin: ".u-filters-range-slider-min",
          rangeSliderMax: ".u-filters-range-slider-max",
          rangeInputMin: ".u-filters-range-input-min",
          rangeInputMax: ".u-filters-range-input-max",
        }),
        (this.$form = this.querySelector(this.selector.form)),
        (this.$toggle = this.querySelector(this.selector.toggle)),
        (this.$range = this.querySelector(this.selector.range)),
        this.targets &&
          this.sectionId &&
          (this.addEventListener("click", this.clearFilters.bind(this)),
          this.$form &&
            (this.$form.addEventListener("submit", this.submitForm.bind(this)),
            this.$toggle &&
              this.addEventListener("change", this.toggleFilter.bind(this)),
            this.$range &&
              (this.addEventListener("input", this.rangeSlice.bind(this)),
              this.addEventListener(
                "input",
                T(this.rangeInput.bind(this), 800),
              ),
              this.addEventListener(
                "".concat(this.customEventPrefix, ":range-slider:change"),
                this.rangeSlice.bind(this),
              ),
              this.addEventListener(
                "".concat(this.customEventPrefix, ":range-slider:change"),
                T(this.rangeInput.bind(this), 600),
              ),
              this.addEventListener("input", this.rangeSlider.bind(this)))),
          this.retrievePreviousOpenedAccordions &&
            this.addEventListener("toggle", this.toggleAccordions.bind(this))));
    }
    get targets() {
      const e = [];
      if (this.dataset.targets)
        for (let t of this.dataset.targets.split(","))
          ((t = t.trim()), t && e.push(t));
      return e.length > 0 ? e : null;
    }
    get sectionId() {
      return this.dataset.sectionId;
    }
    get sectionElement() {
      return (
        (this.sectionId &&
          document.getElementById("shopify-section-".concat(this.sectionId))) ||
        null
      );
    }
    get customEventPrefix() {
      return "filters";
    }
    get focusTo() {
      return (
        (this.dataset.focusTo &&
          this.sectionElement.querySelector(this.dataset.focusTo)) ||
        null
      );
    }
    get gap() {
      return L() + 30;
    }
    get retrievePreviousOpenedAccordions() {
      return !0;
    }
    get currentOpenedAccordions() {
      return this.retrievePreviousOpenedAccordions && tt;
    }
    toggleFilter(e) {
      e.target.closest(this.selector.toggle) &&
        (this.classList.add("is-pending"),
        this.$form &&
          this.$form.dispatchEvent(
            new Event("submit", { bubbles: !0, cancelable: !0 }),
          ));
    }
    clearFilters(e) {
      e.target.closest(this.selector.clear) &&
        (e.preventDefault(),
        this.classList.add("is-pending"),
        this.renderContent(e.target.closest(this.selector.clear).href));
    }
    submitForm(e) {
      e.preventDefault();
      const t = new URL(
          window.location.href.replace(window.location.search, ""),
        ),
        s = Array.from(new FormData(this.$form)).filter((n) => n[1]),
        i = new URLSearchParams(s).toString();
      (i && (t.search = i), this.renderContent(t.toString()));
    }
    rangeSlice(e) {
      if (
        e.target.closest(this.selector.range) &&
        e.target
          .closest(this.selector.range)
          .querySelector(this.selector.rangeInputMin) &&
        e.target
          .closest(this.selector.range)
          .querySelector(this.selector.rangeInputMax)
      ) {
        const t = e.target
            .closest(this.selector.range)
            .querySelector(this.selector.rangeInputMin),
          s = e.target
            .closest(this.selector.range)
            .querySelector(this.selector.rangeInputMax);
        (parseInt(t.value) >= parseInt(s.getAttribute("max"))
          ? (t.value = parseInt(s.getAttribute("max") - 1))
          : parseInt(t.value) < parseInt(t.getAttribute("min")) &&
            (t.value = parseInt(t.getAttribute("min"))),
          parseInt(s.value) >= parseInt(s.getAttribute("max"))
            ? (s.value = parseInt(s.getAttribute("max")))
            : parseInt(s.value) < parseInt(t.getAttribute("min")) &&
              (s.value = parseInt(t.getAttribute("min"))),
          t.value &&
            s.value &&
            (t.setAttribute("max", parseInt(s.value) - 1),
            s.setAttribute("min", parseInt(t.value) + 1)));
      }
    }
    rangeInput(e) {
      if (
        e.target.closest(this.selector.rangeInputMin) ||
        e.target.closest(this.selector.rangeInputMax)
      ) {
        const t =
          e.target.closest(this.selector.rangeInputMin) ||
          e.target.closest(this.selector.rangeInputMax);
        (parseInt(t.value) > parseInt(t.getAttribute("max")) &&
          (t.value = parseInt(t.getAttribute("max"))),
          parseInt(t.value) < parseInt(t.getAttribute("min")) &&
            (t.value = parseInt(t.getAttribute("min"))),
          t.value && (t.value = parseInt(t.value)),
          this.classList.add("is-pending"),
          this.$form &&
            this.$form.dispatchEvent(
              new Event("submit", { bubbles: !0, cancelable: !0 }),
            ));
      }
    }
    rangeSlider(e) {
      if (e.target.closest(this.selector.rangeSliderMin)) {
        const t = e.target
            .closest(this.selector.range)
            .querySelector(this.selector.rangeInputMin),
          s = e.target
            .closest(this.selector.range)
            .querySelector(this.selector.rangeInputMax);
        let i = parseInt(e.target.closest(this.selector.rangeSliderMin).value);
        (i > t.max && (i = t.max),
          (t.value = i),
          (e.target.value = i),
          e.target
            .closest(this.selector.range)
            .style.setProperty(
              "--track-min",
              "".concat((100 / (100 / i)) * (100 / s.max), "%"),
            ),
          t.dispatchEvent(
            new CustomEvent(
              "".concat(this.customEventPrefix, ":range-slider:change"),
              { bubbles: !0 },
            ),
          ));
      }
      if (e.target.closest(this.selector.rangeSliderMax)) {
        const t = e.target
          .closest(this.selector.range)
          .querySelector(this.selector.rangeInputMax);
        let s = parseInt(e.target.closest(this.selector.rangeSliderMax).value);
        (s < t.min && (s = t.min),
          (t.value = s),
          (e.target.value = s),
          e.target
            .closest(this.selector.range)
            .style.setProperty(
              "--track-max",
              "".concat(100 - (100 / (100 / s)) * (100 / t.max), "%"),
            ),
          t.dispatchEvent(
            new CustomEvent(
              "".concat(this.customEventPrefix, ":range-slider:change"),
              { bubbles: !0 },
            ),
          ));
      }
    }
    toggleAccordions(e) {
      if (e.target.closest("u-accordion")) {
        const t = e.target.closest("u-accordion");
        new Set(
          Array.from(
            t.querySelectorAll('input[name*="filter."], input[name="sort_by"]'),
            (i) => i.name,
          ),
        ).forEach((i) => {
          t.open
            ? this.currentOpenedAccordions.add(i)
            : this.currentOpenedAccordions.delete(i);
        });
      }
    }
    reopenAccordions(e) {
      e.querySelectorAll("u-accordion").forEach((t) => {
        new Set(
          Array.from(
            t.querySelectorAll('input[name*="filter."], input[name="sort_by"]'),
            (i) => i.name,
          ),
        ).forEach((i) => {
          this.currentOpenedAccordions.has(i) && t.setAttribute("open", "");
        });
      });
    }
    async renderContent(e, t = !0, s) {
      var o;
      const i = new URL(e);
      if (
        (i.searchParams.set("section_id", this.sectionId), !this.sectionElement)
      )
        throw new Error("this.sectionElement was not found");
      (this.sectionElement.classList.add("is-pending"),
        (o = this.sectionElement.abortController) == null || o.abort(),
        (this.sectionElement.abortController = new AbortController()));
      const n = await h(i.toString(), {
          signal: this.sectionElement.abortController.signal,
        }),
        r = await n.text(),
        a = new DOMParser().parseFromString(r, "text/html").body;
      if (n.ok === !1)
        throw new Error("Something went wrong in Filters.renderContent()");
      this.sectionElement.querySelector(this.targets) &&
        (this.currentOpenedAccordions &&
          this.currentOpenedAccordions.size > 0 &&
          this.reopenAccordions(a),
        $(this.sectionElement, this.targets, a),
        s && $(this.sectionElement, s, a, !0),
        s || history.replaceState({ path: e.toString() }, null, e.toString()),
        t &&
          window.scrollTo({
            top: parseInt(
              this.sectionElement.getBoundingClientRect().top +
                window.scrollY -
                this.gap,
            ),
            behavior: "smooth",
          }),
        this.focusTo && this.focusTo.focus({ preventScroll: !0 }),
        this.classList.remove("is-pending"),
        this.sectionElement.classList.remove("is-pending"),
        this.sectionElement.dispatchEvent(
          new CustomEvent(
            "".concat(this.customEventPrefix, ":render-content:complete"),
            { bubbles: !0 },
          ),
        ));
    }
  },
  st = class extends H {
    constructor() {
      (super(),
        this.targets &&
          this.sectionId &&
          this.addEventListener("click", this.changeSort.bind(this)));
    }
    get customEventPrefix() {
      return "sort-by";
    }
    changeSort(e) {
      if (
        e.target.closest("button") &&
        e.target.closest("button").dataset.value
      ) {
        e.preventDefault();
        const t = new URL(window.location.href);
        (t.searchParams.set(
          "sort_by",
          e.target.closest("button").dataset.value,
        ),
          t.searchParams.delete("page"),
          this.renderContent(t.toString()));
      }
    }
  },
  it = class extends H {
    constructor() {
      (super(),
        this.targets &&
          this.sectionId &&
          this.addEventListener("click", this.changePage.bind(this)));
    }
    get targetsAppend() {
      const e = [];
      if (this.dataset.targetsAppend)
        for (let t of this.dataset.targetsAppend.split(","))
          ((t = t.trim()), t && e.push(t));
      return e.length > 0 ? e : null;
    }
    get customEventPrefix() {
      return "pagination";
    }
    changePage(e) {
      e.target.closest("a") &&
        (e.preventDefault(),
        this.renderContent(
          e.target.closest("a").href,
          !this.targetsAppend,
          this.targetsAppend,
        ));
    }
  },
  nt = class extends HTMLSelectElement {
    constructor() {
      (super(),
        this.addEventListener(
          "change",
          this.updateProvinceVisibility.bind(this),
        ));
    }
    get provinceContainerId() {
      return this.dataset.provinceContainerId;
    }
    get provinceContainerElement() {
      return document.getElementById("".concat(this.provinceContainerId));
    }
    get provinceSelectElement() {
      return this.provinceContainerElement.querySelector("select");
    }
    connectedCallback() {
      (this.dataset.default && this.selectedValue(this),
        this.provinceContainerElement &&
          (this.updateProvinceVisibility(),
          this.provinceSelectElement.dataset.default &&
            this.selectedValue(this.provinceSelectElement)));
    }
    selectedValue(e) {
      for (let t of e.options)
        if (t.text === e.dataset.default || t.value === e.dataset.default) {
          e.selectedIndex = t.index;
          break;
        }
    }
    updateProvinceVisibility() {
      const e = this.options[this.selectedIndex];
      if (this.provinceContainerElement && e && this.provinceSelectElement) {
        const t = JSON.parse(e.dataset.provinces || "[]");
        if (
          ((this.provinceSelectElement.innerHTML = ""),
          this.provinceContainerElement.classList.add("is-hidden"),
          t.length > 0)
        ) {
          for (let s of t) {
            const i =
              s[1] === this.provinceSelectElement.dataset.default ||
              s[0] === this.provinceSelectElement.dataset.default;
            this.provinceSelectElement.options.add(
              new Option(s[1], s[0], i, i),
            );
          }
          this.provinceContainerElement.classList.remove("is-hidden");
        } else this.provinceSelectElement.options.add(new Option("", ""));
        this.provinceSelectElement.dispatchEvent(
          new CustomEvent("form:field:check-value", { bubbles: !0 }),
        );
      }
    }
  },
  rt = class extends HTMLSelectElement {
    constructor() {
      (super(), this.addEventListener("change", this.updateUrl.bind(this)));
    }
    updateUrl() {
      window.location.assign(this.value);
    }
  },
  ot = class extends HTMLButtonElement {
    constructor() {
      (super(), this.addEventListener("click", this.copyHandler.bind(this)));
    }
    get copyValue() {
      return this.dataset.value || "";
    }
    get targetedElement() {
      return (
        (this.dataset.target && document.querySelector(this.dataset.target)) ||
        null
      );
    }
    copyHandler(e) {
      (e.preventDefault(),
        navigator.clipboard.writeText(this.copyValue),
        (this.targetedElement || this).classList.add("is-copied"),
        setTimeout(() => {
          (this.targetedElement || this).classList.remove("is-copied");
        }, 3e3));
    }
  },
  at = class extends HTMLButtonElement {
    constructor() {
      (super(),
        this.addEventListener("click", this.triggerClickHandler.bind(this)));
    }
    get triggerValue() {
      return (
        (this.dataset.value && document.querySelector(this.dataset.value)) ||
        null
      );
    }
    get focusToValue() {
      return this.dataset.focusToValue === "true";
    }
    triggerClickHandler(e) {
      (e.preventDefault(),
        this.triggerValue &&
          setTimeout(() => {
            (this.triggerValue.click(),
              this.focusToValue &&
                this.triggerValue.focus({ preventScroll: !0 }));
          }, 0));
    }
  },
  m = window.ResizeObserver
    ? new ResizeObserver((e) => {
        requestAnimationFrame(() => {
          e.forEach((t) => {
            t.target.updateSizes(t.contentRect.width);
          });
        });
      })
    : null,
  ct = class extends HTMLImageElement {
    constructor() {
      (super(),
        this.sizesAuto ||
          this.addEventListener("load", this.updateClasses.bind(this)));
    }
    static get observedAttributes() {
      return ["src", "sizes"];
    }
    get sizesAuto() {
      return !!(this.dataset.sizesAuto && this.dataset.sizesAuto === "true");
    }
    connectedCallback() {
      this.sizesAuto && m
        ? m.observe(this)
        : this.sizesAuto && m === null
          ? (this.sizes = "".concat(this.getAttribute("width") || 0, "px"))
          : this.complete === !0 && this.updateClasses();
    }
    disconnectedCallback() {
      m && m.unobserve(this);
    }
    attributeChangedCallback(e, t, s) {
      switch (e) {
        case "src":
          t !== null &&
            t !== s &&
            (this.classList.replace("is-loaded", "is-loading"),
            this.addEventListener("load", this.updateClasses.bind(this), {
              once: !0,
            }));
          break;
        case "sizes":
          this.sizesAuto &&
            s &&
            ((this.stockedSizes = s),
            this.dataset.srcset &&
              ((this.srcset = this.dataset.srcset),
              this.removeAttribute("data-srcset"),
              this.addEventListener("load", this.updateClasses.bind(this), {
                once: !0,
              })));
          break;
      }
    }
    updateClasses() {
      this.classList.replace("is-loading", "is-loaded");
    }
    updateSizes(e) {
      this.sizes =
        e <= 0 && this.stockedSizes
          ? this.stockedSizes
          : "".concat(Math.round(e), "px");
    }
  };
let lt = {
  default: "",
  giftMessage:
    /[^a-zA-ZÀ-ÿ0-9 \u0027\u2018\u2019\u00AB\u00BB\u0023\u002B\u003D\u003C\u003E \b \n ;:,._\-!()/&@]/gi,
};
const dt = class extends HTMLElement {
    constructor() {
      (super(),
        (this.selector = { counter: ".u-field-restriction-counter" }),
        (this.$field = this.querySelector(
          'input:not([type="hidden"]), textarea',
        )),
        (this.$counter = this.querySelector(this.selector.counter)),
        this.$field &&
          (this.$field.addEventListener("input", this.checkField.bind(this)),
          this.$field.addEventListener("focusout", this.checkField.bind(this)),
          this.$field.addEventListener(
            "field-restriction:check",
            this.checkField.bind(this),
          )),
        this.$field &&
          this.$counter &&
          (this.$field.addEventListener("input", this.updateCounter.bind(this)),
          this.$field.addEventListener(
            "focusout",
            this.updateCounter.bind(this),
          ),
          this.$field.addEventListener(
            "field-restriction:check",
            this.updateCounter.bind(this),
          )));
    }
    get trim() {
      return (this._trim = this._trim || this.dataset.trim !== "false");
    }
    get limit() {
      return (this._limit = this._limit || parseInt(this.dataset.limit) || !1);
    }
    get lines() {
      return (this._lines = this._lines || parseInt(this.dataset.lines) || !1);
    }
    get pattern() {
      return (this._pattern =
        this._pattern ||
        (this.dataset.pattern && lt[this.dataset.pattern]) ||
        !1);
    }
    get uppercase() {
      return (this._uppercase =
        this._uppercase || this.dataset.uppercase === "true");
    }
    connectedCallback() {
      this.$field &&
        this.$field.dispatchEvent(
          new CustomEvent("field-restriction:check", { bubbles: !0 }),
        );
    }
    checkField(e) {
      const t = this.$field.value;
      let s = this.$field.selectionStart;
      if (
        (this.trim && (this.$field.value = this.$field.value.trimStart()),
        this.trim &&
          e.type !== "input" &&
          (this.$field.value = this.$field.value.trimEnd()),
        this.pattern &&
          (this.$field.value = this.$field.value.replace(this.pattern, "")),
        (this.trim || this.pattern) && t !== this.$field.value && (s = s - 1),
        this.uppercase && (this.$field.value = this.$field.value.toUpperCase()),
        this.$field.type === "textarea" &&
          this.lines &&
          this.$field.value.split("\n").length > this.lines)
      ) {
        const i = this.$field.value;
        this.$field.value = "";
        for (let n in i.split("\n"))
          this.$field.value +=
            i.split("\n")[n] + (n < this.lines - 1 ? "\n" : "");
      }
      (this.limit &&
        this.$field.value.length >= this.limit &&
        (this.$field.value = this.$field.value.substring(0, this.limit)),
        s !== this.$field.selectionStart &&
          this.$field.setSelectionRange(s, s));
    }
    updateCounter() {
      ((this.$counter.innerHTML = this.$field.value.length),
        this.$counter.closest("[aria-live][aria-atomic]") &&
          (this.limit - this.$field.value.length <= 10
            ? this.$counter
                .closest("[aria-live][aria-atomic]")
                .setAttribute("aria-live", "assertive")
            : this.$counter
                .closest("[aria-live][aria-atomic]")
                .setAttribute("aria-live", "off")));
    }
  },
  ut = class extends HTMLFormElement {
    constructor() {
      (super(),
        (this.selector = {
          toggle: ".u-packaging-form-toggle",
          accordion: ".u-packaging-form-accordion",
          textarea: ".u-packaging-form-textarea",
          postButton: ".u-packaging-form-button",
        }),
        (this.$toggle = this.querySelector(this.selector.toggle)),
        (this.$accordion = this.querySelector(this.selector.accordion)),
        (this.$textarea = this.querySelector(this.selector.textarea)),
        (this.$postButton = this.querySelector(this.selector.postButton)),
        this.$toggle.addEventListener("change", this.toggleHandler.bind(this)),
        this.addEventListener("submit", this.saveMessage.bind(this)),
        this.$textarea.addEventListener(
          "input",
          this.updatePostButtonEvent.bind(this),
        ),
        (this.updatePostButtonEventListener =
          this.updatePostButtonEvent.bind(this)));
    }
    connectedCallback() {
      document.addEventListener(
        "uniqart:attributes:update:message:success",
        this.updatePostButtonEventListener,
      );
    }
    disconnectedCallback() {
      document.removeEventListener(
        "uniqart:attributes:update:message:success",
        this.updatePostButtonEventListener,
      );
    }
    get messageEnabled() {
      return this.$toggle.checked;
    }
    get savedMessage() {
      return theme.user.cart.attributes.message;
    }
    toggleHandler(e) {
      this.messageEnabled
        ? ((this.$accordion.open = !0),
          (this.$accordion.open = "focus"),
          (this.$toggle.nextElementSibling.innerHTML =
            theme.strings.cart.message.remove))
        : ((this.$accordion.open = !1),
          (this.$toggle.nextElementSibling.innerHTML =
            theme.strings.cart.message.add),
          (this.$textarea.value = ""),
          this.savedMessage !== void 0 &&
            b({ attributes: { message: "" }, subEvent: "message" }));
    }
    saveMessage(e) {
      e.preventDefault();
      const t = this.$textarea.value.trim();
      (this.$postButton.classList.add("is-progress"),
        this.$textarea.dispatchEvent(
          new CustomEvent("field-restriction:check", { bubbles: !0 }),
        ),
        t
          ? b({ attributes: { message: t }, subEvent: "message" })
          : theme.user.cart.attributes.message &&
            b({ attributes: { message: "" }, subEvent: "message" }));
    }
    updatePostButtonEvent(e) {
      e.type === "input"
        ? this.$textarea.value.trim() !== this.savedMessage
          ? (this.$postButton.removeAttribute("disabled"),
            (this.$postButton.querySelector(".btn__label").innerHTML =
              theme.strings.cart.message.submit))
          : (this.$postButton.querySelector(".btn__label").innerHTML =
              theme.strings.cart.message.success)
        : (this.$postButton.classList.remove("is-progress"),
          (this.$postButton.querySelector(".btn__label").innerHTML =
            theme.strings.cart.message.success),
          this.$textarea.removeAttribute("disabled"),
          e.detail.cart.attributes.message ||
            (this.$postButton.querySelector(".btn__label").innerHTML =
              theme.strings.cart.message.submit),
          setTimeout(() => {
            this.$postButton.classList.remove("is-success");
          }, 2e3));
    }
  },
  ht = class extends U {
    constructor() {
      (super(),
        this.productElement &&
          this.addEventListener(
            "form:pristine:validate",
            this.validateForm.bind(this),
          ),
        (this.variantChangeEventListener = this.variantChangeEvent.bind(this)));
    }
    get productElement() {
      return (this._productElement =
        this._productElement || this.closest("u-product"));
    }
    get inputEmailValue() {
      return this.querySelector('input[name="alert-stock[email]"').value;
    }
    get responseElement() {
      return (
        (this.dataset.response && this.querySelector(this.dataset.response)) ||
        null
      );
    }
    get fetchConfig() {
      return {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2025-01-15",
          "content-type": "application/json",
        },
      };
    }
    connectedCallback() {
      (super.connectedCallback(),
        this.productElement &&
          this.productElement.addEventListener(
            "product:variant:change",
            this.variantChangeEventListener,
          ));
    }
    disconnectedCallback() {
      (super.disconnectedCallback(),
        this.productElement &&
          this.productElement.removeEventListener(
            "product:variant:change",
            this.variantChangeEventListener,
          ));
    }
    variantChangeEvent() {
      ((this.resetPristine = "reinit"),
        this.responseElement &&
          ((this.responseElement.innerHTML = ""),
          this.responseElement.classList.remove(
            "is-visible",
            "form__response--error",
          )));
    }
    async validateForm() {
      const e = theme.settings.klaviyoApi ? theme.settings.klaviyoApi : "",
        t = this.fetchConfig;
      if (!e) return;
      ((t.body = JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: { email: this.inputEmailValue },
              },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$shopify:::$default:::".concat(
                  this.productElement.currentVariant.id,
                ),
              },
            },
          },
        },
      })),
        this.classList.add("is-pending"),
        this.querySelectorAll("input, button").forEach((i) => {
          ((i.hasFocusBeforeDisabled = i.contains(document.activeElement)),
            i.setAttribute("disabled", "disabled"));
        }),
        this.responseElement &&
          ((this.responseElement.innerHTML = ""),
          this.responseElement.classList.remove(
            "is-visible",
            "form__response--error",
          )));
      const s = await fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=".concat(
          e,
        ),
        t,
      );
      (this.classList.remove("is-pending"),
        this.querySelectorAll("input, button").forEach((i) => {
          (i.removeAttribute("disabled"),
            i.hasFocusBeforeDisabled === !0 &&
              (i.focus({ preventScroll: !0 }),
              (i.hasFocusBeforeDisabled = !1)));
        }),
        this.responseElement && s.ok === !0
          ? (this.responseElement.innerHTML =
              theme.strings.product.emailAlertSuccess)
          : (this.responseElement.classList.add("form__response--error"),
            (this.responseElement.innerHTML =
              theme.strings.product.emailAlertError)),
        this.responseElement &&
          (this.responseElement.classList.add("is-visible"),
          this.responseElement.focus()));
    }
  },
  M = class extends HTMLElement {
    constructor() {
      (super(),
        (this.addSuccessEventListener = this.addSuccessEvent.bind(this)),
        (this.removeSuccessEventListener = this.removeSuccessEvent.bind(this)));
    }
    connectedCallback() {
      (document.addEventListener(
        "wishlist:add:success",
        this.addSuccessEventListener,
      ),
        document.addEventListener(
          "wishlist:remove:success",
          this.removeSuccessEventListener,
        ));
    }
    disconnectedCallback() {
      (document.removeEventListener(
        "wishlist:add:success",
        this.addSuccessEventListener,
      ),
        document.removeEventListener(
          "wishlist:remove:success",
          this.removeSuccessEventListener,
        ));
    }
    addSuccessEvent(e) {
      this.renderContent(e.detail);
    }
    removeSuccessEvent(e) {
      this.renderContent(e.detail);
    }
    renderContent(e) {}
  },
  pt = class extends HTMLButtonElement {
    constructor() {
      (super(),
        (this.requestStartedEventListener =
          this.requestStartedEvent.bind(this)),
        (this.requestCompleteEventListener =
          this.requestCompleteEvent.bind(this)),
        (this.addSuccessEventListener = this.addSuccessEvent.bind(this)),
        (this.removeSuccessEventListener = this.removeSuccessEvent.bind(this)),
        this.addEventListener("click", this.toggleHandler.bind(this)));
    }
    get wishlistId() {
      return (
        (this.dataset.wishlistId && parseInt(this.dataset.wishlistId)) || 1
      );
    }
    get productId() {
      return (
        this.dataset.wishlistProductId &&
        parseInt(this.dataset.wishlistProductId)
      );
    }
    get productHandle() {
      return this.dataset.wishlistProductHandle;
    }
    get isActive() {
      return !!this.classList.contains("is-active");
    }
    connectedCallback() {
      (document.addEventListener(
        "wishlist:request:started",
        this.requestStartedEventListener,
      ),
        document.addEventListener(
          "wishlist:request:complete",
          this.requestCompleteEventListener,
        ),
        document.addEventListener(
          "wishlist:add:success",
          this.addSuccessEventListener,
        ),
        document.addEventListener(
          "wishlist:remove:success",
          this.removeSuccessEventListener,
        ));
    }
    disconnectedCallback() {
      (document.removeEventListener(
        "wishlist:request:started",
        this.requestStartedEventListener,
      ),
        document.removeEventListener(
          "wishlist:request:complete",
          this.requestCompleteEventListener,
        ),
        document.removeEventListener(
          "wishlist:add:success",
          this.addSuccessEventListener,
        ),
        document.removeEventListener(
          "wishlist:remove:success",
          this.removeSuccessEventListener,
        ));
    }
    requestStartedEvent() {
      ((this.hasFocusBeforeDisabled = this.contains(document.activeElement)),
        this.setAttribute("disabled", "disabled"));
    }
    requestCompleteEvent() {
      (this.removeAttribute("disabled"),
        this.hasFocusBeforeDisabled === !0 &&
          (this.focus({ preventScroll: !0 }),
          (this.hasFocusBeforeDisabled = !1)));
    }
    addSuccessEvent(e) {
      this.updateState(e);
    }
    removeSuccessEvent(e) {
      this.updateState(e);
    }
    toggleHandler(e) {
      this.hasAttribute("disabled") ||
        (this.isActive
          ? (this.setAttribute("aria-selected", "false"),
            this.classList.remove("is-active"),
            oe(this.wishlistId, this.productId))
          : (this.setAttribute("aria-selected", "true"),
            this.classList.add("is-active"),
            re(this.wishlistId, this.productId, this.productHandle)));
    }
    updateState(e) {
      const t =
          e.type === "wishlist:get:success"
            ? JSON.parse(e.detail.list)
            : e.detail.list,
        s = Object.values(t).find((i) => i.id === this.productId);
      (this.setAttribute("aria-selected", s ? "true" : "false"),
        this.classList.toggle("is-active", !!s));
    }
  },
  mt = class extends M {
    constructor() {
      super();
    }
    renderContent(e) {
      e.itemQtyActive > 0
        ? this.classList.add("is-active")
        : this.classList.remove("is-active");
    }
  },
  ft = class extends M {
    constructor() {
      (super(),
        (this.selector = { products: ".u-wishlist-results-products" }),
        (this.getSuccessEventListener = this.getSuccessEvent.bind(this)),
        (this.pageshowEventListener = this.pageshowEvent.bind(this)));
    }
    get sectionId() {
      return this.dataset.sectionId;
    }
    getSearchQuery(e) {
      return e.map((s) => "id:".concat(s.id)).join(" OR ");
    }
    connectedCallback() {
      theme.wishlist.customerId !== !1 &&
        (super.connectedCallback(),
        document.addEventListener(
          "wishlist:get:success",
          this.getSuccessEventListener,
        ),
        window.addEventListener("pageshow", this.pageshowEventListener),
        this.getList());
    }
    disconnectedCallback() {
      (super.disconnectedCallback(),
        document.removeEventListener(
          "wishlist:get:success",
          this.getSuccessEventListener,
        ),
        window.removeEventListener("pageshow", this.pageshowEventListener));
    }
    getSuccessEvent(e) {
      this.renderContent(e.detail);
    }
    pageshowEvent(e) {
      !this.hasInitialResponse && e.persisted && this.getList();
    }
    getList() {
      (this.classList.add("is-pending"), ae());
    }
    async renderContent(e) {
      var n;
      const t = typeof e.list == "string" ? JSON.parse(e.list) : e.list,
        s = Object.values(t)
          .filter((r) => r.active === !0)
          .reverse(),
        i = new URL(theme.routes.searchUrl, window.location.href);
      if (
        (i.searchParams.set("section_id", this.sectionId),
        s.length > 0 &&
          (i.searchParams.set("type", "product"),
          i.searchParams.set("q", this.getSearchQuery(s)),
          i.searchParams.set("options[unavailable_products]", "show")),
        this.classList.add("is-pending"),
        (n = this.abortController) == null || n.abort(),
        (this.abortController = new AbortController()),
        i)
      ) {
        const r = await h(i.toString(), {
            signal: this.abortController.signal,
          }),
          a = await r.text(),
          o = new DOMParser().parseFromString(a, "text/html").body;
        if (((this.hasInitialResponse = !0), r.ok === !1))
          throw new Error(
            "Something went wrong in WishlistResults.renderContent()",
          );
        if (o.querySelector(this.localName)) {
          const c = o.querySelector(this.selector.products),
            d = c && c.cloneNode(!0);
          if (c) {
            c.innerHTML = "";
            for (let l of s)
              d.querySelector(
                '.product[data-product-id="'.concat(l.id, '"]'),
              ) &&
                c.insertAdjacentHTML(
                  "beforeend",
                  d.querySelector(
                    '.product[data-product-id="'.concat(l.id, '"]'),
                  ).outerHTML,
                );
          }
        }
        ((this.innerHTML = o.querySelector(this.localName).innerHTML),
          this.classList.remove("is-pending"));
      }
    }
  },
  gt = class extends M {
    constructor() {
      super();
    }
    connectedCallback() {
      (super.connectedCallback(),
        theme.wishlist.customerId === !1 &&
          window.location.hash === "#wishlist" &&
          (this.setAttribute("data-wishlist-status", "incentive"),
          (this.innerHTML = this.getAttribute(
            "data-wishlist-status-incentive",
          ))));
    }
    disconnectedCallback() {
      (super.disconnectedCallback(), clearTimeout(this.noficationTimer));
    }
    async renderContent(e) {
      (clearTimeout(this.noficationTimer),
        this.setAttribute("data-wishlist-status", e.wishlistStatus),
        (this.innerHTML = this.getAttribute(
          "data-wishlist-status-".concat(e.wishlistStatus),
        )),
        (this.noficationTimer = setTimeout(() => {
          this.setAttribute("data-wishlist-status", "");
        }, 5e3)));
    }
  },
  J = (e, t) => {
    const s = L() + 30,
      i = document.querySelector(t),
      n = () => {
        setTimeout(() => {
          (window.scrollTo({
            top: parseInt(i.getBoundingClientRect().top + window.scrollY - s),
            behavior: "smooth",
          }),
            setTimeout(() => {
              i.focus({ preventScroll: !0 });
            }, 50));
        }, 500);
      };
    window.location.href && window.location.href.indexOf(e) !== -1 && i && n();
  },
  vt = () => {
    const e = (t) => {
      (t.type === "keydown" &&
        t.key === "Tab" &&
        (document.body.classList.replace("no-focus-outline", "focus-outline"),
        document.removeEventListener("keydown", e),
        document.addEventListener("click", e)),
        t.type === "click" &&
          t.pointerType &&
          (document.body.classList.replace("focus-outline", "no-focus-outline"),
          document.removeEventListener("click", e),
          document.addEventListener("keydown", e)));
    };
    document.addEventListener("keydown", e);
  },
  E = (e) => {
    document.querySelectorAll("[data-cart-visibility]").forEach((t) => {
      const s = t.dataset.cartVisibility;
      (s === "not_empty" && e > 0) || (s === "empty" && e === 0)
        ? t.classList.add("is-visible")
        : t.classList.remove("is-visible");
    });
  },
  Et = () => {
    const e = () => {
        (document.body.classList.add("cart-is-loading"),
          document.querySelectorAll('button[name="add"]').forEach((o) => {
            ((o.hasFocusBeforeDisabled = o.contains(document.activeElement)),
              o.setAttribute("disabled", "disabled"));
          }));
      },
      t = (o) => {
        const c = o.detail.cart;
        ((theme.user.cart = c || theme.user.cart),
          document.body.classList.remove("cart-is-loading"),
          document.querySelectorAll('button[name="add"]').forEach((d) => {
            (d.removeAttribute("disabled"),
              d.hasFocusBeforeDisabled === !0 &&
                (d.focus({ preventScroll: !0 }),
                (d.hasFocusBeforeDisabled = !1)));
          }));
      },
      s = (o) => {
        const c = o.detail.cart,
          d = document.querySelectorAll(
            'u-modal[open], u-drawer[open]:not([data-name="cart"])',
          );
        if (
          (E(c.item_count),
          document
            .querySelectorAll('button[name="add"].is-progress')
            .forEach((l) => {
              (l.classList.remove("is-progress"),
                l.classList.add("is-success"));
            }),
          d.length > 0 &&
            setTimeout(() => {
              d.forEach((l) => {
                l.open = !1;
              });
            }, 400),
          theme.settings.cartDrawer === !1 &&
            document.querySelector("u-minicart"))
        ) {
          const l = document.querySelector("u-minicart");
          ((l.querySelector(".minicart__content").scrollTop = 0),
            d.length > 0
              ? setTimeout(() => {
                  l.open = !0;
                }, 600)
              : l.open ||
                setTimeout(() => {
                  l.open = !0;
                }, 400));
        }
        if (
          document.querySelector('u-drawer-confirm, u-drawer[data-name="cart"]')
        ) {
          const l =
              document.querySelector("u-drawer-confirm") ||
              document.querySelector('u-drawer[data-name="cart"]'),
            O = document.querySelector('u-drawer[data-name="cart"]');
          ((l.querySelector(".drawer__body").scrollTop = 0),
            d.length > 0 && !O.open
              ? setTimeout(() => {
                  l.open = !0;
                }, 600)
              : !l.open &&
                !O.open &&
                setTimeout(() => {
                  l.open = !0;
                }, 400));
        }
        setTimeout(() => {
          document
            .querySelectorAll('button[name="add"].is-success')
            .forEach((l) => {
              l.classList.remove("is-success");
            });
        }, 600);
      },
      i = async (o) => {
        (document.querySelectorAll('button[name="add"]').forEach((c) => {
          c.classList.remove("is-progress");
        }),
          o.detail.status === 422 &&
            (await ce()).item_count !== theme.user.cart.item_count &&
            R());
      },
      n = (o) => {
        const c = o.detail.cart;
        E(c.item_count);
      },
      r = (o) => {
        const c = o.detail.cart;
        E(c.item_count);
      },
      a = (o) => {
        const c = o.detail.cart;
        E(c.item_count);
      };
    (document.addEventListener("uniqart:request:started", e.bind(void 0)),
      document.addEventListener("uniqart:request:complete", t.bind(void 0)),
      document.addEventListener("uniqart:add:success", s.bind(void 0)),
      document.addEventListener("uniqart:add:error", i.bind(void 0)),
      document.addEventListener("uniqart:add[]:success", s.bind(void 0)),
      document.addEventListener("uniqart:add[]:error", i.bind(void 0)),
      document.addEventListener("uniqart:update:success", n.bind(void 0)),
      document.addEventListener("uniqart:refresh:success", r.bind(void 0)),
      document.addEventListener("uniqart:remove[]:success", a.bind(void 0)));
  },
  W = () => {
    R();
  },
  bt = () => {
    window.addEventListener("pageshow", (e) => {
      (e.persisted ||
        (typeof window.performance < "u" &&
          window.performance.getEntriesByType("navigation")[0] &&
          window.performance.getEntriesByType("navigation")[0].type ===
            "back_forward")) &&
        setTimeout(() => {
          W();
        }, 0);
    });
  },
  x = (e = document, t) => {
    (le(
      e.querySelectorAll('[data-animation="zoom"]'),
      (s) => {
        const i =
          getComputedStyle(s).getPropertyValue("--animation-zoom-value") ||
          "1.10";
        D(
          s,
          { transform: ["scale(".concat(i, ")"), "scale(1)"] },
          { duration: 0.5 },
        );
      },
      { margin: "0% 0% -50% 0%" },
    ),
      e.querySelectorAll('[data-animation="parallax"]').forEach((s) => {
        const i =
          getComputedStyle(s).getPropertyValue("--animation-parallax-value") ||
          "20%";
        (de(
          D(s, {
            transform: [
              "translate3d(0, -".concat(i, ", 0)"),
              "translate3d(0, ".concat(i, ", 0)"),
            ],
          }),
          { target: s, offset: ["-100% 100vh", "100% -100vh"] },
        ),
          t &&
            t.type === "shopify:section:load" &&
            window.dispatchEvent(new CustomEvent("scroll")));
      }));
  };
w.addValidator(
  "min",
  function (e, t) {
    const s = this.type === "date" ? parseInt(e.replace(/-/g, "")) : e,
      i = this.type === "date" ? parseInt(t.replace(/-/g, "")) : t;
    return e ? !(s < i) : !0;
  },
  !1,
  1,
  !1,
);
w.addValidator(
  "max",
  function (e, t) {
    const s = this.type === "date" ? parseInt(e.replace(/-/g, "")) : e,
      i = this.type === "date" ? parseInt(t.replace(/-/g, "")) : t;
    return e ? !(s > i) : !0;
  },
  !1,
  1,
  !1,
);
ue.polyfill();
window.refreshCart || (window.refreshCart = W);
window.customElements.define("u-accordion", he);
window.customElements.define("u-dropdown", pe);
window.customElements.define("u-anchor-link", me, { extends: "a" });
window.customElements.define("u-cycle-text", fe, { extends: "ul" });
window.customElements.define("u-quantity-switcher", ge);
window.customElements.define("u-scroll-direction", ve, { extends: "body" });
window.customElements.define("u-sticky", Ee);
window.customElements.define("u-form", U, { extends: "form" });
window.customElements.define("u-video", be);
window.customElements.define("u-header", He);
window.customElements.define("u-toggle-megaroll", Me, { extends: "a" });
window.customElements.define("u-megaroll", Oe);
window.customElements.define("u-hero", _e);
window.customElements.define("u-toggle-link", Be, { extends: "a" });
window.customElements.define("u-toggle-button", Fe, { extends: "button" });
window.customElements.define("u-grid-switcher", Ve, { extends: "button" });
window.customElements.define("u-drawer", Q);
window.customElements.define("u-drawer-confirm", De);
window.customElements.define("u-modal", Ne);
window.customElements.define("u-offcanvas", Re);
window.customElements.define("u-offcanvas-submenu", Ue);
window.customElements.define("u-product", C);
window.customElements.define("u-product-gallery", We);
window.customElements.define("u-product-form", G);
window.customElements.define("u-product-variant-selector", je);
window.customElements.define("u-product-variant-selector-trigger", Ye, {
  extends: "input",
});
window.customElements.define("u-product-price", A);
window.customElements.define("u-product-price-compare", Qe);
window.customElements.define("u-product-price-percentage", Ge);
window.customElements.define("u-product-link", Je, { extends: "a" });
window.customElements.define("u-product-form-box", ze);
window.customElements.define("u-recommendations", Ke);
window.customElements.define("u-recently-viewed", Y);
window.customElements.define("u-predictive-search", Xe);
window.customElements.define("u-slider", S);
window.customElements.define("u-slider-desktop", Ze);
window.customElements.define("u-slider-mobile", et);
window.customElements.define("u-filters", H);
window.customElements.define("u-sort-by", st);
window.customElements.define("u-pagination", it);
window.customElements.define("u-country-selector", nt, { extends: "select" });
window.customElements.define("u-url-selector", rt, { extends: "select" });
window.customElements.define("u-copy-button", ot, { extends: "button" });
window.customElements.define("u-trigger-click-button", at, {
  extends: "button",
});
window.customElements.define("u-lazy-image", ct, { extends: "img" });
window.customElements.define("u-field-restriction", dt);
window.customElements.define("u-cart-counter", ye);
window.customElements.define("u-cart-counter-with-label", Le);
window.customElements.define("u-cart-price", Se);
window.customElements.define("u-cart-total-discount", Ce);
window.customElements.define("u-cart-delivery", ke);
window.customElements.define("u-cart-lines", qe);
window.customElements.define("u-cart-line", j);
window.customElements.define("u-cart-line-box", xe);
window.customElements.define("u-cart-last-line", $e);
window.customElements.define("u-cart-notification", Pe);
window.customElements.define("u-cart-upsell", Te);
window.customElements.define("u-cart-add", Ie, { extends: "button" });
window.customElements.define("u-email-alert-form", ht, { extends: "form" });
window.customElements.define("u-cart-recently-viewed", Ae);
window.customElements.define("u-packaging-form", ut, { extends: "form" });
theme.wishlist &&
  (window.customElements.define("u-wishlist-add", pt, { extends: "button" }),
  window.customElements.define("u-wishlist-counter", mt),
  window.customElements.define("u-wishlist-results", ft),
  window.customElements.define("u-wishlist-notification", gt));
J("challenge#contact_form", ".shopify-challenge__message");
J("?contact_posted=true", ".form--contact .form__success");
vt();
Et();
bt();
window.Animation &&
  (x(),
  ["filters", "pagination", "sort-by"].forEach((e) => {
    document.addEventListener("".concat(e, ":render-content:complete"), (t) => {
      x(t.target);
    });
  }),
  window.Shopify.designMode &&
    document.addEventListener("shopify:section:load", (e) => {
      x(e.target, e);
    }));
window.location.hash === "#search" &&
  (document.querySelector('u-drawer[data-name="search"]').open = !0);
theme.settings.cartDrawer === !0 &&
  window.location.hash === "#cart" &&
  (document.querySelector('u-drawer[data-name="cart"]').open = !0);
window.location.hash === "#email-alert" &&
  (document.querySelector('u-modal[data-name="product-email-alert"]').open =
    !0);
